// import React, { useEffect, useState, useRef } from "react";
// import axios from "axios";

// const API_URL = "https://ecom.cyberathon.com/index.php/Api/list_video";
// const BASE_URL = "https://ecom.cyberathon.com/";
// const FREE_SECONDS = 10;

// // ─── Render HTML safely ──────────────────────────────────────────────────────
// const HtmlContent = ({ html, className = "", maxLines = null }) => {
//   if (!html) return null;
//   const style = maxLines
//     ? {
//         display: "-webkit-box",
//         WebkitLineClamp: maxLines,
//         WebkitBoxOrient: "vertical",
//         overflow: "hidden",
//       }
//     : {};
//   return (
//     <div
//       className={className}
//       style={style}
//       dangerouslySetInnerHTML={{ __html: html }}
//     />
//   );
// };

// // ─── YouTube API Loader ──────────────────────────────────────────────────────
// function loadYouTubeAPI() {
//   if (window.YT && window.YT.Player) return Promise.resolve();
//   if (window.__ytApiPromise) return window.__ytApiPromise;
//   window.__ytApiPromise = new Promise((resolve) => {
//     window.onYouTubeIframeAPIReady = resolve;
//     const tag = document.createElement("script");
//     tag.src = "https://www.youtube.com/iframe_api";
//     document.body.appendChild(tag);
//   });
//   return window.__ytApiPromise;
// }

// function getYouTubeId(embedUrl) {
//   if (!embedUrl) return "";
//   const match = embedUrl.match(/embed\/([^?&]+)/);
//   return match ? match[1] : "";
// }

// // ─── Add to Cart helper ──────────────────────────────────────────────────────
// async function addToCartApi(prod_id, onSuccess, onError) {
//   const userId = sessionStorage.getItem("userId");
//   if (!userId) {
//     alert("Please login first!");
//     return;
//   }
//   try {
//     const res = await axios.post(
//       "https://ecom.cyberathon.com/index.php/Api/insert_cart",
//       { user_id: Number(userId), prod_id: Number(prod_id), qty: 1 }
//     );
//     if (res.data.status === true) onSuccess();
//     else onError(res.data.message || "Failed to add");
//   } catch (e) {
//     console.error(e);
//     onError("Something went wrong");
//   }
// }

// // ─── Lock Overlay ────────────────────────────────────────────────────────────
// const LockOverlay = ({ onReplay, prod_id, isAdded, onAddedChange }) => {
//   const [loading, setLoading] = useState(false);

//   const handleCart = async () => {
//     if (isAdded) return;
//     setLoading(true);
//     await addToCartApi(
//       prod_id,
//       () => {
//         onAddedChange(true);
//         setLoading(false);
//       },
//       (msg) => {
//         alert(msg);
//         setLoading(false);
//       }
//     );
//   };

//   return (
//     <div className="lock-overlay">
//       <div className="lock-pulse-ring" />
//       <div className="lock-icon-wrap">
//         <svg
//           width="28"
//           height="28"
//           viewBox="0 0 24 24"
//           fill="none"
//           stroke="#fff"
//           strokeWidth="2.2"
//           strokeLinecap="round"
//           strokeLinejoin="round"
//         >
//           <rect x="3" y="11" width="18" height="11" rx="2" />
//           <path d="M7 11V7a5 5 0 0 1 10 0v4" />
//         </svg>
//       </div>
//       <p className="lock-title">Preview Ended</p>
//       <p className="lock-sub">Purchase this course to unlock full access</p>
//       <button
//         className={`btn-lock-cart${isAdded ? " added" : ""}`}
//         onClick={handleCart}
//         disabled={loading || isAdded}
//       >
//         {loading ? (
//           <span className="cs-spinner" />
//         ) : isAdded ? (
//           <>
//             <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="20 6 9 17 4 12" /></svg>
//             Added to Cart
//           </>
//         ) : (
//           <>
//             <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="9" cy="21" r="1" /><circle cx="20" cy="21" r="1" /><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" /></svg>
//             Add to Cart
//           </>
//         )}
//       </button>
//       <button className="btn-replay" onClick={onReplay}>
//         <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2"><polyline points="1 4 1 10 7 10" /><path d="M3.51 15a9 9 0 1 0 .49-6" /></svg>
//         Watch Preview Again
//       </button>
//     </div>
//   );
// };

// // ─── Device Video Card ───────────────────────────────────────────────────────
// const DeviceVideoCard = ({ video, isPurchased, isAdded: initAdded, onCartChange }) => {
//   const [phase, setPhase] = useState("idle");
//   const [isAdded, setIsAdded] = useState(initAdded);
//   const [cartLoading, setCartLoading] = useState(false);
//   const videoRef = useRef(null);
//   const timerRef = useRef(null);

//   useEffect(() => {
//     setIsAdded(initAdded);
//   }, [initAdded]);

//   const handlePlay = () => setPhase("playing");

//   useEffect(() => {
//     if (phase !== "playing") return;
//     const vid = videoRef.current;
//     if (!vid || isPurchased) return;
//     const onPlay = () => {
//       timerRef.current = setTimeout(() => {
//         vid.pause();
//         setPhase("locked");
//       }, FREE_SECONDS * 1000);
//     };
//     vid.addEventListener("play", onPlay);
//     return () => {
//       vid.removeEventListener("play", onPlay);
//       clearTimeout(timerRef.current);
//     };
//   }, [phase, isPurchased]);

//   const handleReplay = () => {
//     clearTimeout(timerRef.current);
//     setPhase("idle");
//   };

//   const handleAddedChange = (val) => {
//     setIsAdded(val);
//     if (onCartChange) onCartChange(video.prod_id, val);
//   };

//   const handleCartClick = async () => {
//     if (isAdded) return;
//     setCartLoading(true);
//     await addToCartApi(
//       video.prod_id,
//       () => {
//         setIsAdded(true);
//         if (onCartChange) onCartChange(video.prod_id, true);
//         setCartLoading(false);
//       },
//       (msg) => {
//         alert(msg);
//         setCartLoading(false);
//       }
//     );
//   };

//   return (
//     <div className="course-card">
//       <div className="video-area">
//         {isPurchased ? (
//           <span className="badge badge-purchased">
//             <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3"><polyline points="20 6 9 17 4 12" /></svg>
//             Purchased
//           </span>
//         ) : (
//           <span className="badge badge-preview">
//             <svg width="11" height="11" viewBox="0 0 24 24" fill="currentColor"><polygon points="5,3 19,12 5,21" /></svg>
//             {FREE_SECONDS}s Free Preview
//           </span>
//         )}

//         {phase === "idle" && (
//           <>
//             <video
//               src={video.embedUrl}
//               style={{ width: "100%", height: "100%", objectFit: "cover" }}
//               preload="metadata"
//             />
//             <div className="play-overlay">
//               <button className="play-btn" onClick={handlePlay}>
//                 <svg width="20" height="20" viewBox="0 0 24 24" fill="white">
//                   <polygon points="5,3 19,12 5,21" />
//                 </svg>
//               </button>
//             </div>
//           </>
//         )}

//         {(phase === "playing" || phase === "locked") && (
//           <>
//             <video
//               ref={videoRef}
//               src={video.embedUrl}
//               controls
//               autoPlay
//               playsInline
//               style={{ width: "100%", height: "100%", objectFit: "cover" }}
//             />
//             {phase === "locked" && (
//               <LockOverlay
//                 onReplay={handleReplay}
//                 prod_id={video.prod_id}
//                 isAdded={isAdded}
//                 onAddedChange={handleAddedChange}
//               />
//             )}
//           </>
//         )}
//       </div>

//       <div className="card-body-inner">
//         <h3 className="card-title">{video.heading}</h3>

//         {video.description && (
//           <div className="card-desc html-content">
//             <HtmlContent html={video.description} maxLines={3} />
//           </div>
//         )}

//         {video.details && (
//           <div className="card-details html-content">
//             <HtmlContent html={video.details} maxLines={2} />
//           </div>
//         )}

//         <div className="price-row">
//           {video.current_price && Number(video.current_price) > 0 ? (
//             <>
//               <span className="price-current">
//                 ₹{Number(video.current_price).toLocaleString("en-IN")}
//               </span>
//               {video.old_price && Number(video.old_price) > 0 && (
//                 <span className="price-old">
//                   ₹{Number(video.old_price).toLocaleString("en-IN")}
//                 </span>
//               )}
//             </>
//           ) : (
//             <span className="price-free">Free</span>
//           )}
//         </div>

//         {isPurchased ? (
//           <button className="btn-watch" onClick={handlePlay}>
//             <svg width="14" height="14" viewBox="0 0 24 24" fill="white"><polygon points="5,3 19,12 5,21" /></svg>
//             Watch Full Course
//           </button>
//         ) : (
//           <button
//             className={`btn-cart${isAdded ? " added" : ""}`}
//             onClick={handleCartClick}
//             disabled={cartLoading || isAdded}
//           >
//             {cartLoading ? (
//               <span className="cs-spinner" />
//             ) : isAdded ? (
//               <>
//                 <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="20 6 9 17 4 12" /></svg>
//                 Added to Cart
//               </>
//             ) : (
//               <>
//                 <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="9" cy="21" r="1" /><circle cx="20" cy="21" r="1" /><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" /></svg>
//                 Add to Cart
//               </>
//             )}
//           </button>
//         )}
//       </div>
//     </div>
//   );
// };

// // ─── YouTube Video Card ──────────────────────────────────────────────────────
// const VideoCard = ({ video, isPurchased, isAdded: initAdded, onCartChange }) => {
//   const [phase, setPhase] = useState("thumbnail");
//   const [isAdded, setIsAdded] = useState(initAdded);
//   const [cartLoading, setCartLoading] = useState(false);
//   const timerRef = useRef(null);
//   const playerRef = useRef(null);
//   const divId = `yt-player-${video.id}`;

//   const videoId = getYouTubeId(video.embedUrl);
//   const thumbUrl = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;

//   useEffect(() => {
//     setIsAdded(initAdded);
//   }, [initAdded]);

//   const handlePlay = async () => {
//     setPhase("playing");
//     await loadYouTubeAPI();
//     setTimeout(() => {
//       playerRef.current = new window.YT.Player(divId, {
//         events: {
//           onReady: (e) => {
//             e.target.playVideo();
//             if (!isPurchased) {
//               timerRef.current = setTimeout(() => {
//                 e.target.pauseVideo();
//                 setPhase("locked");
//               }, FREE_SECONDS * 1000);
//             }
//           },
//         },
//       });
//     }, 300);
//   };

//   const handleReplay = () => {
//     clearTimeout(timerRef.current);
//     if (playerRef.current) {
//       try {
//         playerRef.current.destroy();
//       } catch (e) {}
//       playerRef.current = null;
//     }
//     setPhase("thumbnail");
//   };

//   useEffect(
//     () => () => {
//       clearTimeout(timerRef.current);
//       if (playerRef.current) {
//         try {
//           playerRef.current.destroy();
//         } catch (e) {}
//       }
//     },
//     []
//   );

//   const handleAddedChange = (val) => {
//     setIsAdded(val);
//     if (onCartChange) onCartChange(video.prod_id, val);
//   };

//   const handleCartClick = async () => {
//     if (isAdded) return;
//     setCartLoading(true);
//     await addToCartApi(
//       video.prod_id,
//       () => {
//         setIsAdded(true);
//         if (onCartChange) onCartChange(video.prod_id, true);
//         setCartLoading(false);
//       },
//       (msg) => {
//         alert(msg);
//         setCartLoading(false);
//       }
//     );
//   };

//   return (
//     <div className="course-card">
//       <div className="video-area">
//         {isPurchased ? (
//           <span className="badge badge-purchased">
//             <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3"><polyline points="20 6 9 17 4 12" /></svg>
//             Purchased
//           </span>
//         ) : (
//           <span className="badge badge-preview">
//             <svg width="11" height="11" viewBox="0 0 24 24" fill="currentColor"><polygon points="5,3 19,12 5,21" /></svg>
//             {FREE_SECONDS}s Free Preview
//           </span>
//         )}

//         {phase === "thumbnail" && (
//           <>
//             <img
//               src={thumbUrl}
//               alt={video.heading}
//               style={{ width: "100%", height: "100%", objectFit: "cover" }}
//             />
//             <div className="play-overlay">
//               <button className="play-btn" onClick={handlePlay}>
//                 <svg width="20" height="20" viewBox="0 0 24 24" fill="white">
//                   <polygon points="5,3 19,12 5,21" />
//                 </svg>
//               </button>
//             </div>
//           </>
//         )}

//         {(phase === "playing" || phase === "locked") && (
//           <>
//             <iframe
//               id={divId}
//               src={`https://www.youtube.com/embed/${videoId}?enablejsapi=1`}
//               title={video.heading}
//               allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
//               allowFullScreen
//               style={{ width: "100%", height: "100%", border: "none" }}
//             />
//             {phase === "locked" && (
//               <LockOverlay
//                 onReplay={handleReplay}
//                 prod_id={video.prod_id}
//                 isAdded={isAdded}
//                 onAddedChange={handleAddedChange}
//               />
//             )}
//           </>
//         )}
//       </div>

//       {/* ── Card Body ── */}
//       <div className="card-body-inner">
//         <h3 className="card-title">{video.heading}</h3>

//         {video.description && (
//           <div className="card-desc html-content">
//             <HtmlContent html={video.description} maxLines={3} />
//           </div>
//         )}

//         {video.details && (
//           <div className="card-details html-content">
//             <HtmlContent html={video.details} maxLines={2} />
//           </div>
//         )}

//         <div className="price-row">
//           {video.current_price && Number(video.current_price) > 0 ? (
//             <>
//               <span className="price-current">
//                 ₹{Number(video.current_price).toLocaleString("en-IN")}
//               </span>
//               {video.old_price && Number(video.old_price) > 0 && (
//                 <span className="price-old">
//                   ₹{Number(video.old_price).toLocaleString("en-IN")}
//                 </span>
//               )}
//             </>
//           ) : (
//             <span className="price-free">Free</span>
//           )}
//         </div>

//         {isPurchased ? (
//           <button className="btn-watch" onClick={handlePlay}>
//             <svg width="14" height="14" viewBox="0 0 24 24" fill="white"><polygon points="5,3 19,12 5,21" /></svg>
//             Watch Full Course
//           </button>
//         ) : (
//           <button
//             className={`btn-cart${isAdded ? " added" : ""}`}
//             onClick={handleCartClick}
//             disabled={cartLoading || isAdded}
//           >
//             {cartLoading ? (
//               <span className="cs-spinner" />
//             ) : isAdded ? (
//               <>
//                 <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="20 6 9 17 4 12" /></svg>
//                 Added to Cart
//               </>
//             ) : (
//               <>
//                 <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="9" cy="21" r="1" /><circle cx="20" cy="21" r="1" /><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" /></svg>
//                 Add to Cart
//               </>
//             )}
//           </button>
//         )}
//       </div>
//     </div>
//   );
// };

// // ─── MAIN COMPONENT ──────────────────────────────────────────────────────────
// const CourseSection2 = () => {
//   const [videos, setVideos] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");
//   const [purchasedProdIds, setPurchasedProdIds] = useState(new Set());
//   const [cartProdIds, setCartProdIds] = useState(new Set());

//   // ── Fetch videos ──
//   useEffect(() => {
//     const load = async () => {
//       try {
//         const res = await axios.get(API_URL);
//         if (!res.data.status) {
//           setError("No videos found");
//           return;
//         }
//         const list = res.data.videos.map((v) => {
//           let embedUrl = v.video || "";
//           if (embedUrl && !embedUrl.startsWith("http"))
//             embedUrl = BASE_URL + embedUrl;

//           let type = "file";
//           if (
//             embedUrl.includes("youtube.com") ||
//             embedUrl.includes("youtu.be")
//           ) {
//             type = "youtube";
//             let videoId = "";
//             if (embedUrl.includes("watch?v="))
//               videoId = new URLSearchParams(new URL(embedUrl).search).get("v");
//             else if (embedUrl.includes("youtu.be/"))
//               videoId = embedUrl.split("youtu.be/")[1].split("?")[0];
//             else if (embedUrl.includes("embed/"))
//               videoId = embedUrl.split("embed/")[1].split("?")[0];
//             embedUrl = `https://www.youtube.com/embed/${videoId}`;
//           }
//           return { ...v, type, embedUrl };
//         });
//         setVideos(list);
//       } catch (e) {
//         setError("Failed to fetch videos");
//       } finally {
//         setLoading(false);
//       }
//     };
//     load();
//   }, []);

//   // ── Fetch purchased orders + cart ──
//   useEffect(() => {
//     const init = async () => {
//       const userId = sessionStorage.getItem("userId");
//       const cartToken = localStorage.getItem("cart_token");

//       // Cart items
//       if (userId || cartToken) {
//         try {
//           const res = await axios.post(
//             "https://ecom.cyberathon.com/index.php/Api/list_cart",
//             {
//               user_id: userId || null,
//               cart_token: userId ? null : cartToken,
//             }
//           );
//           if (res.data.status) {
//             const ids = new Set(
//               res.data.cart_items.map((i) => String(i.prod_id))
//             );
//             setCartProdIds(ids);
//           }
//         } catch (e) {
//           console.error(e);
//         }
//       }

//       // Purchased orders
//       if (userId) {
//         try {
//           const res = await axios.post(
//             "https://ecom.cyberathon.com/index.php/Api/list_new_order",
//             { user_id: parseInt(userId) }
//           );
//           if (res.data.status && Array.isArray(res.data.orders)) {
//             const purchasedIds = new Set();
//             res.data.orders.forEach((order) => {
//               if (!Array.isArray(order.items)) return;
//               order.items.forEach((item) => {
//                 if (!item.prod_id) return;
//                 if (
//                   item.access === "unlocked" ||
//                   order.purchase_status === "yes" ||
//                   order.payment_status === "Paid" ||
//                   order.payment_status === "paid" ||
//                   order.order_status === "Delivered" ||
//                   order.order_status === "Completed"
//                 ) {
//                   purchasedIds.add(String(item.prod_id));
//                 }
//               });
//             });
//             setPurchasedProdIds(purchasedIds);
//           }
//         } catch (e) {
//           console.error(e);
//         }
//       }
//     };
//     init();
//   }, []);

//   const handleCartChange = (prod_id, added) => {
//     setCartProdIds((prev) => {
//       const next = new Set(prev);
//       if (added) next.add(String(prod_id));
//       else next.delete(String(prod_id));
//       return next;
//     });
//   };

//   return (
//     <>
//       <style>{`
//         @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&family=DM+Sans:wght@400;500;600&display=swap');

//         :root {
//           --teal: #0ecfce;
//           --teal-dark: #0ab5b4;
//           --teal-glow: rgba(14,207,206,0.18);
//           --green: #22c55e;
//           --green-dark: #16a34a;
//           --red-old: #ef4444;
//           --card-bg: #ffffff;
//           --card-border: #e5f7f7;
//           --card-hover-border: #0ecfce;
//           --text-primary: #0f172a;
//           --text-secondary: #475569;
//           --text-muted: #94a3b8;
//           --surface: #f8fffe;
//           --badge-preview-bg: rgba(14,207,206,0.12);
//           --badge-preview-color: #0891b2;
//           --badge-purchased-bg: rgba(34,197,94,0.12);
//           --badge-purchased-color: #15803d;
//         }

//         .cs-root {
//           background: var(--surface);
//           min-height: 60vh;
//           padding: 64px 0 80px;
//           font-family: 'DM Sans', sans-serif;
//         }

//         /* ── HEADER ── */
//         .cs-header {
//           text-align: center;
//           margin-bottom: 52px;
//           padding: 0 16px;
//         }
//         .cs-eyebrow {
//           display: inline-flex;
//           align-items: center;
//           gap: 6px;
//           background: var(--badge-preview-bg);
//           color: var(--badge-preview-color);
//           font-size: 12px;
//           font-weight: 700;
//           letter-spacing: 1px;
//           text-transform: uppercase;
//           padding: 5px 14px;
//           border-radius: 100px;
//           margin-bottom: 16px;
//           font-family: 'Plus Jakarta Sans', sans-serif;
//         }
//         .cs-heading {
//           font-family: 'Plus Jakarta Sans', sans-serif;
//           font-size: clamp(1.9rem, 3.5vw, 2.8rem);
//           font-weight: 800;
//           color: var(--text-primary);
//           margin: 0 0 10px;
//           letter-spacing: -0.8px;
//           line-height: 1.15;
//         }
//         .cs-sub {
//           color: var(--text-muted);
//           font-size: 15px;
//           margin: 0;
//         }

//         /* ── GRID ── */
//         .cs-grid {
//           display: grid;
//           grid-template-columns: repeat(auto-fill, minmax(310px, 1fr));
//           gap: 24px;
//           padding: 0 24px;
//           max-width: 1240px;
//           margin: 0 auto;
//         }

//         /* ── CARD ── */
//         .course-card {
//           background: var(--card-bg);
//           border: 1.5px solid var(--card-border);
//           border-radius: 20px;
//           overflow: hidden;
//           display: flex;
//           flex-direction: column;
//           transition: transform 0.28s cubic-bezier(.22,.68,0,1.2), box-shadow 0.28s ease, border-color 0.2s ease;
//           animation: csCardIn 0.45s ease both;
//           position: relative;
//         }
//         .course-card:hover {
//           transform: translateY(-7px);
//           box-shadow: 0 20px 52px rgba(14,207,206,0.13), 0 4px 16px rgba(0,0,0,0.06);
//           border-color: var(--card-hover-border);
//         }
//         @keyframes csCardIn {
//           from { opacity: 0; transform: translateY(22px); }
//           to   { opacity: 1; transform: translateY(0); }
//         }

//         /* ── VIDEO AREA ── */
//         .video-area {
//           position: relative;
//           width: 100%;
//           height: 205px;
//           background: #0d1117;
//           overflow: hidden;
//           flex-shrink: 0;
//         }
//         .video-area img,
//         .video-area video,
//         .video-area iframe {
//           width: 100%;
//           height: 100%;
//           object-fit: cover;
//           display: block;
//         }

//         /* ── PLAY OVERLAY ── */
//         .play-overlay {
//           position: absolute;
//           inset: 0;
//           background: rgba(0,0,0,0.28);
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           z-index: 4;
//           transition: background 0.2s;
//         }
//         .play-overlay:hover { background: rgba(0,0,0,0.38); }

//         .play-btn {
//           width: 56px;
//           height: 56px;
//           border-radius: 50%;
//           background: var(--teal);
//           border: 3px solid rgba(255,255,255,0.3);
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           cursor: pointer;
//           transition: transform 0.2s cubic-bezier(.22,.68,0,1.4), background 0.2s;
//           box-shadow: 0 4px 24px rgba(14,207,206,0.45);
//         }
//         .play-btn:hover {
//           transform: scale(1.12);
//           background: var(--teal-dark);
//         }
//         .play-btn svg { margin-left: 3px; }

//         /* ── BADGES ── */
//         .badge {
//           position: absolute;
//           top: 12px;
//           left: 12px;
//           display: inline-flex;
//           align-items: center;
//           gap: 5px;
//           font-size: 11px;
//           font-weight: 700;
//           padding: 4px 10px;
//           border-radius: 100px;
//           z-index: 5;
//           letter-spacing: 0.2px;
//           font-family: 'Plus Jakarta Sans', sans-serif;
//           backdrop-filter: blur(8px);
//         }
//         .badge-preview {
//           background: rgba(14,207,206,0.18);
//           color: #fff;
//           border: 1px solid rgba(14,207,206,0.4);
//         }
//         .badge-purchased {
//           background: rgba(34,197,94,0.18);
//           color: #fff;
//           border: 1px solid rgba(34,197,94,0.4);
//         }

//         /* ── LOCK OVERLAY ── */
//         .lock-overlay {
//           position: absolute;
//           inset: 0;
//           background: rgba(8,12,20,0.93);
//           backdrop-filter: blur(6px);
//           display: flex;
//           flex-direction: column;
//           align-items: center;
//           justify-content: center;
//           z-index: 10;
//           padding: 24px 20px;
//           text-align: center;
//           gap: 9px;
//           animation: csLockIn 0.22s ease;
//         }
//         @keyframes csLockIn {
//           from { opacity: 0; transform: scale(0.97); }
//           to   { opacity: 1; transform: scale(1); }
//         }
//         .lock-pulse-ring {
//           position: absolute;
//           width: 90px;
//           height: 90px;
//           border-radius: 50%;
//           border: 1.5px solid rgba(14,207,206,0.25);
//           animation: lockPulse 2s ease-in-out infinite;
//           pointer-events: none;
//         }
//         @keyframes lockPulse {
//           0%, 100% { transform: scale(1); opacity: 0.5; }
//           50% { transform: scale(1.3); opacity: 0; }
//         }
//         .lock-icon-wrap {
//           width: 58px;
//           height: 58px;
//           border-radius: 50%;
//           background: rgba(14,207,206,0.1);
//           border: 1.5px solid rgba(14,207,206,0.3);
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           position: relative;
//           z-index: 1;
//         }
//         .lock-title {
//           font-family: 'Plus Jakarta Sans', sans-serif;
//           font-size: 15px;
//           font-weight: 800;
//           color: #f1f5f9;
//           margin: 2px 0 0;
//           letter-spacing: -0.2px;
//         }
//         .lock-sub {
//           font-size: 12px;
//           color: #64748b;
//           margin: 0;
//           line-height: 1.55;
//           max-width: 200px;
//         }
//         .btn-lock-cart {
//           background: var(--teal);
//           color: #fff;
//           border: none;
//           border-radius: 10px;
//           padding: 9px 22px;
//           font-size: 13px;
//           font-weight: 700;
//           cursor: pointer;
//           display: flex;
//           align-items: center;
//           gap: 7px;
//           transition: opacity 0.2s, transform 0.15s;
//           font-family: 'Plus Jakarta Sans', sans-serif;
//           letter-spacing: 0.1px;
//           margin-top: 2px;
//         }
//         .btn-lock-cart:hover:not(:disabled) {
//           opacity: 0.88;
//           transform: translateY(-1px);
//         }
//         .btn-lock-cart.added {
//           background: #16a34a;
//           cursor: default;
//         }
//         .btn-lock-cart:disabled { opacity: 0.7; }
//         .btn-replay {
//           background: transparent;
//           color: #475569;
//           border: 1px solid #2d3748;
//           border-radius: 8px;
//           padding: 6px 14px;
//           font-size: 11.5px;
//           font-weight: 600;
//           cursor: pointer;
//           display: flex;
//           align-items: center;
//           gap: 5px;
//           transition: color 0.2s, border-color 0.2s;
//           font-family: 'DM Sans', sans-serif;
//         }
//         .btn-replay:hover { color: #94a3b8; border-color: #475569; }

//         /* ── CARD BODY ── */
//         .card-body-inner {
//           padding: 18px 20px 20px;
//           display: flex;
//           flex-direction: column;
//           flex: 1;
//           gap: 10px;
//         }

//         .card-title {
//           font-family: 'Plus Jakarta Sans', sans-serif;
//           font-size: 15.5px;
//           font-weight: 700;
//           color: var(--text-primary);
//           margin: 0;
//           line-height: 1.4;
//           letter-spacing: -0.2px;
//         }

//         /* ── HTML Content render fix ── */
//         .html-content ul,
//         .html-content ol {
//           padding-left: 20px;
//           margin: 4px 0;
//         }
//         .html-content ul li,
//         .html-content ol li {
//           color: var(--text-secondary);
//           font-size: 13px;
//           margin-bottom: 3px;
//           line-height: 1.6;
//         }
//         .html-content p {
//           margin: 0 0 4px;
//           color: var(--text-secondary);
//           font-size: 13px;
//           line-height: 1.65;
//         }
//         .html-content strong { color: var(--text-primary); }
//         .html-content a { color: var(--teal); text-decoration: none; }

//         .card-desc {
//           font-size: 13px;
//           color: var(--text-secondary);
//           line-height: 1.65;
//         }
//         .card-details {
//           font-size: 12.5px;
//           color: var(--text-muted);
//           line-height: 1.6;
//           border-top: 1px solid #f1f5f9;
//           padding-top: 10px;
//         }

//         /* ── PRICE ── */
//         .price-row {
//           display: flex;
//           align-items: baseline;
//           gap: 10px;
//           margin-top: 2px;
//         }
//         .price-current {
//           font-family: 'Plus Jakarta Sans', sans-serif;
//           font-size: 21px;
//           font-weight: 800;
//           color: var(--green);
//           letter-spacing: -0.5px;
//         }
//         .price-old {
//           font-size: 13.5px;
//           color: var(--text-muted);
//           text-decoration: line-through;
//           font-weight: 500;
//         }
//         .price-free {
//           font-family: 'Plus Jakarta Sans', sans-serif;
//           font-size: 16px;
//           font-weight: 700;
//           color: var(--teal);
//         }

//         /* ── BUTTONS ── */
//         .btn-cart {
//           margin-top: auto;
//           padding: 12px 0;
//           border-radius: 12px;
//           border: 1.5px solid var(--teal);
//           font-size: 13.5px;
//           font-weight: 700;
//           cursor: pointer;
//           background: transparent;
//           color: var(--teal);
//           width: 100%;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           gap: 7px;
//           letter-spacing: 0.1px;
//           transition: background 0.2s, color 0.2s, transform 0.15s;
//           font-family: 'Plus Jakarta Sans', sans-serif;
//         }
//         .btn-cart:hover:not(:disabled):not(.added) {
//           background: var(--teal);
//           color: #fff;
//           transform: translateY(-1px);
//         }
//         .btn-cart.added {
//           background: #f0fdf4;
//           border-color: var(--green);
//           color: var(--green-dark);
//           cursor: default;
//         }
//         .btn-cart:disabled:not(.added) { opacity: 0.65; cursor: not-allowed; }

//         .btn-watch {
//           margin-top: auto;
//           padding: 12px 0;
//           border-radius: 12px;
//           border: none;
//           font-size: 13.5px;
//           font-weight: 700;
//           cursor: pointer;
//           background: linear-gradient(135deg, #22c55e, #16a34a);
//           color: #fff;
//           width: 100%;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           gap: 7px;
//           transition: opacity 0.2s, transform 0.15s;
//           font-family: 'Plus Jakarta Sans', sans-serif;
//           letter-spacing: 0.1px;
//         }
//         .btn-watch:hover {
//           opacity: 0.9;
//           transform: translateY(-1px);
//         }

//         /* ── SPINNER ── */
//         .cs-spinner {
//           display: inline-block;
//           width: 15px;
//           height: 15px;
//           border: 2px solid rgba(255,255,255,0.3);
//           border-top-color: #fff;
//           border-radius: 50%;
//           animation: csSpin 0.7s linear infinite;
//         }
//         @keyframes csSpin { to { transform: rotate(360deg); } }

//         /* ── SKELETON ── */
//         .cs-skeleton-card {
//           background: white;
//           border-radius: 20px;
//           overflow: hidden;
//           border: 1.5px solid #f1f5f9;
//         }
//         .cs-skeleton {
//           background: linear-gradient(90deg, #f8fafc 25%, #f1f5f9 50%, #f8fafc 75%);
//           background-size: 200% 100%;
//           animation: csSkeleton 1.5s ease-in-out infinite;
//           border-radius: 6px;
//         }
//         @keyframes csSkeleton {
//           0% { background-position: -200% 0; }
//           100% { background-position: 200% 0; }
//         }

//         /* ── RESPONSIVE ── */
//         @media (max-width: 600px) {
//           .cs-grid { padding: 0 12px; gap: 16px; }
//           .cs-heading { font-size: 1.7rem; }
//         }
//       `}</style>

//       <div className="cs-root">
//         <div className="container-fluid px-0">
//           <div className="cs-header">
//             <div className="cs-eyebrow">
//               <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polygon points="5,3 19,12 5,21" /></svg>
//               Video Courses
//             </div>
//             <h2 className="cs-heading">Learn From Industry Experts</h2>
//             <p className="cs-sub">Preview any course free · Unlock full access after purchase</p>
//           </div>

//           {/* Loading skeletons */}
//           {loading && (
//             <div className="cs-grid">
//               {[1, 2, 3].map((n) => (
//                 <div key={n} className="cs-skeleton-card">
//                   <div className="cs-skeleton" style={{ height: 205, borderRadius: 0 }} />
//                   <div style={{ padding: "18px 20px 20px", display: "flex", flexDirection: "column", gap: 10 }}>
//                     <div className="cs-skeleton" style={{ height: 18, width: "85%" }} />
//                     <div className="cs-skeleton" style={{ height: 13, width: "70%" }} />
//                     <div className="cs-skeleton" style={{ height: 13, width: "55%" }} />
//                     <div className="cs-skeleton" style={{ height: 28, width: "40%", marginTop: 4 }} />
//                     <div className="cs-skeleton" style={{ height: 46, borderRadius: 12, marginTop: 8 }} />
//                   </div>
//                 </div>
//               ))}
//             </div>
//           )}

//           {error && (
//             <p style={{ textAlign: "center", color: "#ef4444", padding: 40, fontFamily: "'DM Sans', sans-serif" }}>
//               {error}
//             </p>
//           )}

//           {!loading && !error && (
//             <div className="cs-grid">
//               {videos.map((v) => {
//                 const strId = String(v.prod_id);
//                 const isPurchased = purchasedProdIds.has(strId);
//                 const isAdded = cartProdIds.has(strId);

//                 return v.type === "youtube" ? (
//                   <VideoCard
//                     key={v.id}
//                     video={v}
//                     isPurchased={isPurchased}
//                     isAdded={isAdded}
//                     onCartChange={handleCartChange}
//                   />
//                 ) : (
//                   <DeviceVideoCard
//                     key={v.id}
//                     video={v}
//                     isPurchased={isPurchased}
//                     isAdded={isAdded}
//                     onCartChange={handleCartChange}
//                   />
//                 );
//               })}
//             </div>
//           )}
//         </div>
//       </div>
//     </>
//   );
// };

// export default CourseSection2;



//Claude 1 try 18march

// import React, { useEffect, useState, useRef } from "react";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";

// const API_URL = "https://ecom.cyberathon.com/index.php/Api/list_video";
// const BASE_URL = "https://ecom.cyberathon.com/";
// const FREE_SECONDS = 10;

// // ─── Render HTML safely ──────────────────────────────────────────────────────
// const HtmlContent = ({ html, className = "", maxLines = null }) => {
//   if (!html) return null;
//   const style = maxLines
//     ? {
//         display: "-webkit-box",
//         WebkitLineClamp: maxLines,
//         WebkitBoxOrient: "vertical",
//         overflow: "hidden",
//       }
//     : {};
//   return (
//     <div
//       className={className}
//       style={style}
//       dangerouslySetInnerHTML={{ __html: html }}
//     />
//   );
// };

// // ─── YouTube API Loader ──────────────────────────────────────────────────────
// function loadYouTubeAPI() {
//   if (window.YT && window.YT.Player) return Promise.resolve();
//   if (window.__ytApiPromise) return window.__ytApiPromise;
//   window.__ytApiPromise = new Promise((resolve) => {
//     window.onYouTubeIframeAPIReady = resolve;
//     const tag = document.createElement("script");
//     tag.src = "https://www.youtube.com/iframe_api";
//     document.body.appendChild(tag);
//   });
//   return window.__ytApiPromise;
// }
// function getYouTubeId(embedUrl) {
//   if (!embedUrl) return "";
//   const match = embedUrl.match(/embed\/([^?&]+)/);
//   return match ? match[1] : "";
// }

// // ─── Detect video type ───────────────────────────────────────────────────────
// // Returns: "youtube" | "mp4" | "iframe" | "no-video"
// function detectVideoType(url) {
//   if (!url || url.trim() === "") return "no-video";
//   const u = url.toLowerCase();
//   if (u.includes("youtube.com") || u.includes("youtu.be")) return "youtube";
//   if (
//     u.endsWith(".mp4") ||
//     u.endsWith(".webm") ||
//     u.endsWith(".ogg") ||
//     u.includes(".mp4?") ||
//     u.includes("gtv-videos-bucket") ||
//     u.includes("commondatastorage.googleapis.com") ||
//     u.includes("archive.org")
//   )
//     return "mp4";
//   // vimeo, dailymotion, or any other embeddable link
//   if (u.includes("vimeo.com") || u.includes("dailymotion.com"))
//     return "iframe";
//   // fallback: try mp4 player for any http link ending in video extensions
//   return "mp4";
// }

// // Build a proper embed URL for YouTube
// function buildYouTubeEmbedUrl(raw) {
//   try {
//     if (raw.includes("watch?v=")) {
//       const id = new URLSearchParams(new URL(raw).search).get("v");
//       return `https://www.youtube.com/embed/${id}`;
//     }
//     if (raw.includes("youtu.be/")) {
//       const id = raw.split("youtu.be/")[1].split("?")[0];
//       return `https://www.youtube.com/embed/${id}`;
//     }
//     if (raw.includes("embed/")) {
//       return raw; // already embed
//     }
//   } catch (e) {}
//   return raw;
// }

// // Build Vimeo embed URL
// function buildVimeoEmbedUrl(raw) {
//   const match = raw.match(/vimeo\.com\/(\d+)/);
//   if (match) return `https://player.vimeo.com/video/${match[1]}?autoplay=1`;
//   return raw;
// }

// // ─── Add to Cart helper ──────────────────────────────────────────────────────
// async function addToCartApi(prod_id, onSuccess, onError) {
//   const userId = sessionStorage.getItem("userId");
//   if (!userId) {
//     alert("Please login first!");
//     return;
//   }
//   try {
//     const res = await axios.post(
//       "https://ecom.cyberathon.com/index.php/Api/insert_cart",
//       { user_id: Number(userId), prod_id: Number(prod_id), qty: 1 }
//     );
//     if (res.data.status === true) onSuccess();
//     else onError(res.data.message || "Failed to add");
//   } catch (e) {
//     console.error(e);
//     onError("Something went wrong");
//   }
// }

// // ─── No-video placeholder ─────────────────────────────────────────────────────
// const NoVideoPlaceholder = () => (
//   <div className="no-video-placeholder">
//     <svg width="38" height="38" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.25)" strokeWidth="1.4">
//       <rect x="2" y="2" width="20" height="20" rx="2.5" />
//       <path d="M10 8l6 4-6 4V8z" />
//       <line x1="2" y1="2" x2="22" y2="22" />
//     </svg>
//     <span>No Video Available</span>
//   </div>
// );

// // ─── Lock Overlay ────────────────────────────────────────────────────────────
// const LockOverlay = ({ onReplay, prod_id, isAdded, onAddedChange, hideReplay }) => {
//   const [loading, setLoading] = useState(false);

//   const handleCart = async () => {
//     if (isAdded) return;
//     setLoading(true);
//     await addToCartApi(
//       prod_id,
//       () => { onAddedChange(true); setLoading(false); },
//       (msg) => { alert(msg); setLoading(false); }
//     );
//   };

//   return (
//     <div className="lock-overlay">
//       <div className="lock-pulse-ring" />
//       <div className="lock-icon-wrap">
//         <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
//           <rect x="3" y="11" width="18" height="11" rx="2" />
//           <path d="M7 11V7a5 5 0 0 1 10 0v4" />
//         </svg>
//       </div>
//       <p className="lock-title">Preview Ended</p>
//       <p className="lock-sub">Purchase this course to unlock full access</p>
//       {prod_id && (
//         <button
//           className={`btn-lock-cart${isAdded ? " added" : ""}`}
//           onClick={handleCart}
//           disabled={loading || isAdded}
//         >
//           {loading ? (
//             <span className="cs-spinner" />
//           ) : isAdded ? (
//             <>
//               <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="20 6 9 17 4 12" /></svg>
//               Added to Cart
//             </>
//           ) : (
//             <>
//               <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="9" cy="21" r="1" /><circle cx="20" cy="21" r="1" /><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" /></svg>
//               Add to Cart
//             </>
//           )}
//         </button>
//       )}
//       {!hideReplay && (
//         <button className="btn-replay" onClick={onReplay}>
//           <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2"><polyline points="1 4 1 10 7 10" /><path d="M3.51 15a9 9 0 1 0 .49-6" /></svg>
//           Watch Preview Again
//         </button>
//       )}
//     </div>
//   );
// };

// // ─── Video Error Fallback ─────────────────────────────────────────────────────
// const VideoErrorFallback = ({ onRetry }) => (
//   <div className="video-error-fallback">
//     <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.3)" strokeWidth="1.5">
//       <circle cx="12" cy="12" r="10" />
//       <line x1="12" y1="8" x2="12" y2="12" />
//       <line x1="12" y1="16" x2="12.01" y2="16" />
//     </svg>
//     <span>Video could not be loaded</span>
//     {onRetry && (
//       <button className="btn-retry" onClick={onRetry}>Try Again</button>
//     )}
//   </div>
// );

// // ─── MP4 / Direct File Video Card ────────────────────────────────────────────
// const Mp4VideoCard = ({ video, isPurchased, isAdded: initAdded, onCartChange }) => {
//   const [phase, setPhase] = useState("idle"); // idle | playing | locked | error
//   const [isAdded, setIsAdded] = useState(initAdded);
//   const [cartLoading, setCartLoading] = useState(false);
//   const videoRef = useRef(null);
//   const timerRef = useRef(null);

//   useEffect(() => { setIsAdded(initAdded); }, [initAdded]);

//   const handlePlay = () => { setPhase("playing"); };

//   useEffect(() => {
//     if (phase !== "playing") return;
//     const vid = videoRef.current;
//     if (!vid || isPurchased) return;
//     const onPlay = () => {
//       timerRef.current = setTimeout(() => {
//         vid.pause();
//         setPhase("locked");
//       }, FREE_SECONDS * 1000);
//     };
//     vid.addEventListener("play", onPlay);
//     return () => { vid.removeEventListener("play", onPlay); clearTimeout(timerRef.current); };
//   }, [phase, isPurchased]);

//   const handleReplay = () => { clearTimeout(timerRef.current); setPhase("idle"); };

//   const handleAddedChange = (val) => {
//     setIsAdded(val);
//     if (onCartChange) onCartChange(video.prod_id, val);
//   };

//   const handleCartClick = async () => {
//     if (isAdded) return;
//     setCartLoading(true);
//     await addToCartApi(
//       video.prod_id,
//       () => { setIsAdded(true); if (onCartChange) onCartChange(video.prod_id, true); setCartLoading(false); },
//       (msg) => { alert(msg); setCartLoading(false); }
//     );
//   };

//   return (
//     <div className="course-card">
//       <div className="video-area">
//         {isPurchased ? (
//           <span className="badge badge-purchased">
//             <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3"><polyline points="20 6 9 17 4 12" /></svg>
//             Purchased
//           </span>
//         ) : (
//           <span className="badge badge-preview">
//             <svg width="10" height="10" viewBox="0 0 24 24" fill="currentColor"><polygon points="5,3 19,12 5,21" /></svg>
//             {FREE_SECONDS}s Free Preview
//           </span>
//         )}

//         {/* IDLE — show thumbnail + play button */}
//         {phase === "idle" && (
//           <>
//             <video
//               src={`${video.embedUrl}#t=0.5`}
//               style={{ width: "100%", height: "100%", objectFit: "cover" }}
//               preload="metadata"
//               muted
//               playsInline
//             />
//             <div className="play-overlay">
//               <button className="play-btn" onClick={handlePlay}>
//                 <svg width="20" height="20" viewBox="0 0 24 24" fill="white"><polygon points="5,3 19,12 5,21" /></svg>
//               </button>
//             </div>
//           </>
//         )}

//         {/* PLAYING or LOCKED */}
//         {(phase === "playing" || phase === "locked") && (
//           <>
//             <video
//               ref={videoRef}
//               src={video.embedUrl}
//               controls={!isPurchased ? false : true}
//               autoPlay
//               playsInline
//               onError={() => setPhase("error")}
//               style={{ width: "100%", height: "100%", objectFit: "cover" }}
//             />
//             {phase === "locked" && (
//               <LockOverlay
//                 onReplay={handleReplay}
//                 prod_id={video.prod_id}
//                 isAdded={isAdded}
//                 onAddedChange={handleAddedChange}
//               />
//             )}
//           </>
//         )}

//         {/* ERROR */}
//         {phase === "error" && (
//           <VideoErrorFallback onRetry={() => setPhase("idle")} />
//         )}
//       </div>

//       <CardBody
//         video={video}
//         isPurchased={isPurchased}
//         isAdded={isAdded}
//         cartLoading={cartLoading}
//         onWatch={handlePlay}
//         onCart={handleCartClick}
//       />
//     </div>
//   );
// };

// // ─── YouTube Video Card ──────────────────────────────────────────────────────
// const YoutubeVideoCard = ({ video, isPurchased, isAdded: initAdded, onCartChange }) => {
//   const [phase, setPhase] = useState("thumbnail"); // thumbnail | playing | locked
//   const [isAdded, setIsAdded] = useState(initAdded);
//   const [cartLoading, setCartLoading] = useState(false);
//   const timerRef = useRef(null);
//   const playerRef = useRef(null);
//   const divId = `yt-player-${video.id}`;

//   const videoId = getYouTubeId(video.embedUrl);
//   const thumbUrl = videoId
//     ? `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`
//     : null;

//   useEffect(() => { setIsAdded(initAdded); }, [initAdded]);

//   const handlePlay = async () => {
//     setPhase("playing");
//     await loadYouTubeAPI();
//     setTimeout(() => {
//       playerRef.current = new window.YT.Player(divId, {
//         events: {
//           onReady: (e) => {
//             e.target.playVideo();
//             if (!isPurchased) {
//               timerRef.current = setTimeout(() => {
//                 e.target.pauseVideo();
//                 setPhase("locked");
//               }, FREE_SECONDS * 1000);
//             }
//           },
//         },
//       });
//     }, 300);
//   };

//   const handleReplay = () => {
//     clearTimeout(timerRef.current);
//     if (playerRef.current) { try { playerRef.current.destroy(); } catch (e) {} playerRef.current = null; }
//     setPhase("thumbnail");
//   };

//   useEffect(() => () => {
//     clearTimeout(timerRef.current);
//     if (playerRef.current) { try { playerRef.current.destroy(); } catch (e) {} }
//   }, []);

//   const handleAddedChange = (val) => {
//     setIsAdded(val);
//     if (onCartChange) onCartChange(video.prod_id, val);
//   };

//   const handleCartClick = async () => {
//     if (isAdded) return;
//     setCartLoading(true);
//     await addToCartApi(
//       video.prod_id,
//       () => { setIsAdded(true); if (onCartChange) onCartChange(video.prod_id, true); setCartLoading(false); },
//       (msg) => { alert(msg); setCartLoading(false); }
//     );
//   };

//   return (
//     <div className="course-card">
//       <div className="video-area">
//         {isPurchased ? (
//           <span className="badge badge-purchased">
//             <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3"><polyline points="20 6 9 17 4 12" /></svg>
//             Purchased
//           </span>
//         ) : (
//           <span className="badge badge-preview">
//             <svg width="10" height="10" viewBox="0 0 24 24" fill="currentColor"><polygon points="5,3 19,12 5,21" /></svg>
//             {FREE_SECONDS}s Free Preview
//           </span>
//         )}

//         {phase === "thumbnail" && (
//           <>
//             {thumbUrl ? (
//               <img src={thumbUrl} alt={video.heading} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
//             ) : (
//               <div style={{ width: "100%", height: "100%", background: "#0d1117" }} />
//             )}
//             <div className="play-overlay">
//               <button className="play-btn" onClick={handlePlay}>
//                 <svg width="20" height="20" viewBox="0 0 24 24" fill="white"><polygon points="5,3 19,12 5,21" /></svg>
//               </button>
//             </div>
//           </>
//         )}

//         {(phase === "playing" || phase === "locked") && (
//           <>
//             <iframe
//               id={divId}
//               src={`https://www.youtube.com/embed/${videoId}?enablejsapi=1`}
//               title={video.heading}
//               allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
//               allowFullScreen
//               style={{ width: "100%", height: "100%", border: "none" }}
//             />
//             {phase === "locked" && (
//               <LockOverlay
//                 onReplay={handleReplay}
//                 prod_id={video.prod_id}
//                 isAdded={isAdded}
//                 onAddedChange={handleAddedChange}
//               />
//             )}
//           </>
//         )}
//       </div>

//       <CardBody
//         video={video}
//         isPurchased={isPurchased}
//         isAdded={isAdded}
//         cartLoading={cartLoading}
//         onWatch={handlePlay}
//         onCart={handleCartClick}
//       />
//     </div>
//   );
// };

// // ─── IFrame Video Card (Vimeo, Dailymotion, etc.) ────────────────────────────
// const IframeVideoCard = ({ video, isPurchased, isAdded: initAdded, onCartChange }) => {
//   const [phase, setPhase] = useState("thumbnail"); // thumbnail | playing | locked
//   const [isAdded, setIsAdded] = useState(initAdded);
//   const [cartLoading, setCartLoading] = useState(false);
//   const timerRef = useRef(null);

//   useEffect(() => { setIsAdded(initAdded); }, [initAdded]);

//   const handlePlay = () => {
//     setPhase("playing");
//     if (!isPurchased) {
//       timerRef.current = setTimeout(() => {
//         setPhase("locked");
//       }, FREE_SECONDS * 1000);
//     }
//   };

//   const handleReplay = () => {
//     clearTimeout(timerRef.current);
//     setPhase("thumbnail");
//   };

//   useEffect(() => () => clearTimeout(timerRef.current), []);

//   const handleAddedChange = (val) => {
//     setIsAdded(val);
//     if (onCartChange) onCartChange(video.prod_id, val);
//   };

//   const handleCartClick = async () => {
//     if (isAdded) return;
//     setCartLoading(true);
//     await addToCartApi(
//       video.prod_id,
//       () => { setIsAdded(true); if (onCartChange) onCartChange(video.prod_id, true); setCartLoading(false); },
//       (msg) => { alert(msg); setCartLoading(false); }
//     );
//   };

//   const iframeSrc = video.embedUrl.includes("vimeo")
//     ? buildVimeoEmbedUrl(video.embedUrl)
//     : video.embedUrl;

//   return (
//     <div className="course-card">
//       <div className="video-area">
//         {isPurchased ? (
//           <span className="badge badge-purchased">
//             <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3"><polyline points="20 6 9 17 4 12" /></svg>
//             Purchased
//           </span>
//         ) : (
//           <span className="badge badge-preview">
//             <svg width="10" height="10" viewBox="0 0 24 24" fill="currentColor"><polygon points="5,3 19,12 5,21" /></svg>
//             {FREE_SECONDS}s Free Preview
//           </span>
//         )}

//         {phase === "thumbnail" && (
//           <div className="play-overlay" style={{ background: "rgba(0,0,0,0.55)" }}>
//             <button className="play-btn" onClick={handlePlay}>
//               <svg width="20" height="20" viewBox="0 0 24 24" fill="white"><polygon points="5,3 19,12 5,21" /></svg>
//             </button>
//           </div>
//         )}

//         {(phase === "playing" || phase === "locked") && (
//           <>
//             <iframe
//               src={iframeSrc}
//               title={video.heading}
//               allow="autoplay; fullscreen"
//               allowFullScreen
//               style={{ width: "100%", height: "100%", border: "none" }}
//             />
//             {phase === "locked" && (
//               <LockOverlay
//                 onReplay={handleReplay}
//                 prod_id={video.prod_id}
//                 isAdded={isAdded}
//                 onAddedChange={handleAddedChange}
//               />
//             )}
//           </>
//         )}
//       </div>

//       <CardBody
//         video={video}
//         isPurchased={isPurchased}
//         isAdded={isAdded}
//         cartLoading={cartLoading}
//         onWatch={handlePlay}
//         onCart={handleCartClick}
//       />
//     </div>
//   );
// };

// // ─── No Video Card ────────────────────────────────────────────────────────────
// const NoVideoCard = ({ video, isPurchased, isAdded: initAdded, onCartChange }) => {
//   const [isAdded, setIsAdded] = useState(initAdded);
//   const [cartLoading, setCartLoading] = useState(false);

//   useEffect(() => { setIsAdded(initAdded); }, [initAdded]);

//   const handleCartClick = async () => {
//     if (isAdded) return;
//     setCartLoading(true);
//     await addToCartApi(
//       video.prod_id,
//       () => { setIsAdded(true); if (onCartChange) onCartChange(video.prod_id, true); setCartLoading(false); },
//       (msg) => { alert(msg); setCartLoading(false); }
//     );
//   };

//   return (
//     <div className="course-card">
//       <div className="video-area">
//         {isPurchased && (
//           <span className="badge badge-purchased">
//             <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3"><polyline points="20 6 9 17 4 12" /></svg>
//             Purchased
//           </span>
//         )}
//         <NoVideoPlaceholder />
//       </div>
//       <CardBody
//         video={video}
//         isPurchased={isPurchased}
//         isAdded={isAdded}
//         cartLoading={cartLoading}
//         onWatch={null}
//         onCart={handleCartClick}
//       />
//     </div>
//   );
// };

// // ─── Shared Card Body ─────────────────────────────────────────────────────────
// const CardBody = ({ video, isPurchased, isAdded, cartLoading, onWatch, onCart, onNavigate}) => (
//   <div className="card-body-inner">
//     <h3 className="card-title"
//      style={{ cursor: onNavigate ? "pointer" : "default" }}
//       onClick={onNavigate}
//     >{video.heading}</h3>

//     {video.description && (
//       <div className="card-desc html-content">
//         <HtmlContent html={video.description} maxLines={3} />
//       </div>
//     )}

//     {video.details && (
//       <div className="card-details html-content">
//         <HtmlContent html={video.details} maxLines={2} />
//       </div>
//     )}

//     <div className="price-row">
//       {video.current_price && Number(video.current_price) > 0 ? (
//         <>
//           <span className="price-current">
//             ₹{Number(video.current_price).toLocaleString("en-IN")}
//           </span>
//           {video.old_price && Number(video.old_price) > 0 && (
//             <span className="price-old">
//               ₹{Number(video.old_price).toLocaleString("en-IN")}
//             </span>
//           )}
//         </>
//       ) : (
//         <span className="price-free">Free</span>
//       )}
//     </div>

//     {/* No prod_id = no cart button */}
//     {!video.prod_id ? (
//       <div className="no-prod-tag">
//         <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" /></svg>
//         Not available for purchase
//       </div>
//     ) : isPurchased ? (
//       onWatch && (
//         <button className="btn-watch" onClick={onWatch}>
//           <svg width="14" height="14" viewBox="0 0 24 24" fill="white"><polygon points="5,3 19,12 5,21" /></svg>
//           Watch Full Course
//         </button>
//       )
//     ) : (
//       <button
//         className={`btn-cart${isAdded ? " added" : ""}`}
//         onClick={onCart}
//         disabled={cartLoading || isAdded}
//       >
//         {cartLoading ? (
//           <span className="cs-spinner" />
//         ) : isAdded ? (
//           <>
//             <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="20 6 9 17 4 12" /></svg>
//             Added to Cart
//           </>
//         ) : (
//           <>
//             <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="9" cy="21" r="1" /><circle cx="20" cy="21" r="1" /><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" /></svg>
//             Add to Cart
//           </>
//         )}
//       </button>
      
//     )}
//   </div>
// );

// // ─── MAIN COMPONENT ──────────────────────────────────────────────────────────
// const CourseSection2 = () => {
//     const navigate = useNavigate();

//   const [videos, setVideos] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");
//   const [purchasedProdIds, setPurchasedProdIds] = useState(new Set());
//   const [cartProdIds, setCartProdIds] = useState(new Set());

//   // ── Fetch + normalize videos ──
//   useEffect(() => {
//     const load = async () => {
//       try {
//         const res = await axios.get(API_URL);
//         if (!res.data.status) { setError("No videos found"); return; }

//         const list = res.data.videos.map((v) => {
//           let rawUrl = v.video || "";
//           // Prepend base if relative
//           if (rawUrl && !rawUrl.startsWith("http")) rawUrl = BASE_URL + rawUrl;

//           const type = detectVideoType(rawUrl);

//           let embedUrl = rawUrl;
//           if (type === "youtube") embedUrl = buildYouTubeEmbedUrl(rawUrl);

//           return { ...v, type, embedUrl };
//         });

//         setVideos(list);
//       } catch (e) {
//         setError("Failed to fetch videos");
//       } finally {
//         setLoading(false);
//       }
//     };
//     load();
//   }, []);

//   // ── Fetch purchased orders + cart ──
//   useEffect(() => {
//     const init = async () => {
//       const userId = sessionStorage.getItem("userId");
//       const cartToken = localStorage.getItem("cart_token");

//       if (userId || cartToken) {
//         try {
//           const res = await axios.post(
//             "https://ecom.cyberathon.com/index.php/Api/list_cart",
//             { user_id: userId || null, cart_token: userId ? null : cartToken }
//           );
//           if (res.data.status) {
//             setCartProdIds(new Set(res.data.cart_items.map((i) => String(i.prod_id))));
//           }
//         } catch (e) { console.error(e); }
//       }

//       if (userId) {
//         try {
//           const res = await axios.post(
//             "https://ecom.cyberathon.com/index.php/Api/list_new_order",
//             { user_id: parseInt(userId) }
//           );
//           if (res.data.status && Array.isArray(res.data.orders)) {
//             const ids = new Set();
//             res.data.orders.forEach((order) => {
//               if (!Array.isArray(order.items)) return;
//               order.items.forEach((item) => {
//                 if (!item.prod_id) return;
//                 if (
//                   item.access === "unlocked" ||
//                   order.purchase_status === "yes" ||
//                   order.payment_status === "Paid" ||
//                   order.payment_status === "paid" ||
//                   order.order_status === "Delivered" ||
//                   order.order_status === "Completed"
//                 ) {
//                   ids.add(String(item.prod_id));
//                 }
//               });
//             });
//             setPurchasedProdIds(ids);
//           }
//         } catch (e) { console.error(e); }
//       }
//     };
//     init();
//   }, []);

//   const handleCartChange = (prod_id, added) => {
//     setCartProdIds((prev) => {
//       const next = new Set(prev);
//       if (added) next.add(String(prod_id)); else next.delete(String(prod_id));
//       return next;
//     });
//   };

//   // ── Render correct card based on type ──
//   const renderCard = (v) => {
//     const strId = String(v.prod_id);
//     const isPurchased = purchasedProdIds.has(strId);
//     const isAdded = cartProdIds.has(strId);
//     const props = { key: v.id, video: v, isPurchased, isAdded, onCartChange: handleCartChange ,
//         onNavigate : () => navigate(`/coursesectiondetail/${v.id}`),
//     };

//     switch (v.type) {
//       case "youtube":   return <YoutubeVideoCard {...props} />;
//       case "mp4":       return <Mp4VideoCard {...props} />;
//       case "iframe":    return <IframeVideoCard {...props} />;
//       case "no-video":  return <NoVideoCard {...props} />;
//       default:          return <Mp4VideoCard {...props} />;
//     }
//   };

//   return (
//     <>
//       <style>{`
//         @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&family=DM+Sans:wght@400;500;600&display=swap');

//         :root {
//           --teal: #0ecfce;
//           --teal-dark: #0ab5b4;
//           --green: #22c55e;
//           --green-dark: #16a34a;
//           --card-bg: #ffffff;
//           --card-border: #e5f0f0;
//           --card-hover-border: #0ecfce;
//           --text-primary: #0f172a;
//           --text-secondary: #475569;
//           --text-muted: #94a3b8;
//           --surface: #f7fffe;
//         }

//         .cs-root {
//           background: var(--surface);
//           min-height: 60vh;
//           padding: 64px 0 80px;
//           font-family: 'DM Sans', sans-serif;
//         }

//         /* ── HEADER ── */
//         .cs-header {
//           text-align: center;
//           margin-bottom: 52px;
//           padding: 0 16px;
//         }
//         .cs-eyebrow {
//           display: inline-flex;
//           align-items: center;
//           gap: 6px;
//           background: rgba(14,207,206,0.1);
//           color: #0891b2;
//           font-size: 11.5px;
//           font-weight: 700;
//           letter-spacing: 1px;
//           text-transform: uppercase;
//           padding: 5px 14px;
//           border-radius: 100px;
//           margin-bottom: 16px;
//           font-family: 'Plus Jakarta Sans', sans-serif;
//         }
//         .cs-heading {
//           font-family: 'Plus Jakarta Sans', sans-serif;
//           font-size: clamp(1.9rem, 3.5vw, 2.8rem);
//           font-weight: 800;
//           color: var(--text-primary);
//           margin: 0 0 10px;
//           letter-spacing: -0.8px;
//           line-height: 1.15;
//         }
//         .cs-sub { color: var(--text-muted); font-size: 15px; margin: 0; }

//         /* ── GRID ── */
//         .cs-grid {
//           display: grid;
//           grid-template-columns: repeat(auto-fill, minmax(310px, 1fr));
//           gap: 24px;
//           padding: 0 24px;
//           max-width: 1240px;
//           margin: 0 auto;
//         }

//         /* ── CARD ── */
//         .course-card {
//           background: var(--card-bg);
//           border: 1.5px solid var(--card-border);
//           border-radius: 20px;
//           overflow: hidden;
//           display: flex;
//           flex-direction: column;
//           transition: transform 0.28s cubic-bezier(.22,.68,0,1.2), box-shadow 0.28s ease, border-color 0.2s ease;
//           animation: csCardIn 0.45s ease both;
//           position: relative;
//         }
//         .course-card:hover {
//           transform: translateY(-7px);
//           box-shadow: 0 20px 52px rgba(14,207,206,0.12), 0 4px 16px rgba(0,0,0,0.05);
//           border-color: var(--card-hover-border);
//         }
//         @keyframes csCardIn {
//           from { opacity: 0; transform: translateY(22px); }
//           to   { opacity: 1; transform: translateY(0); }
//         }

//         /* ── VIDEO AREA ── */
//         .video-area {
//           position: relative;
//           width: 100%;
//           height: 205px;
//           background: #0d1117;
//           overflow: hidden;
//           flex-shrink: 0;
//         }
//         .video-area img,
//         .video-area video,
//         .video-area iframe {
//           width: 100%; height: 100%;
//           object-fit: cover; display: block;
//         }

//         /* ── NO VIDEO PLACEHOLDER ── */
//         .no-video-placeholder {
//           width: 100%; height: 100%;
//           display: flex; flex-direction: column;
//           align-items: center; justify-content: center;
//           gap: 10px; background: #0d1117;
//         }
//         .no-video-placeholder span {
//           font-size: 12px; color: rgba(255,255,255,0.2);
//           font-family: 'DM Sans', sans-serif; letter-spacing: 0.3px;
//         }

//         /* ── VIDEO ERROR FALLBACK ── */
//         .video-error-fallback {
//           width: 100%; height: 100%;
//           display: flex; flex-direction: column;
//           align-items: center; justify-content: center;
//           gap: 10px; background: #0d1117; padding: 20px; text-align: center;
//         }
//         .video-error-fallback span {
//           font-size: 12px; color: rgba(255,255,255,0.25);
//           font-family: 'DM Sans', sans-serif;
//         }
//         .btn-retry {
//           background: rgba(14,207,206,0.12); color: var(--teal);
//           border: 1px solid rgba(14,207,206,0.3); border-radius: 8px;
//           padding: 5px 14px; font-size: 11.5px; font-weight: 600;
//           cursor: pointer; font-family: 'DM Sans', sans-serif;
//           transition: background 0.2s;
//         }
//         .btn-retry:hover { background: rgba(14,207,206,0.2); }

//         /* ── PLAY OVERLAY ── */
//         .play-overlay {
//           position: absolute; inset: 0;
//           background: rgba(0,0,0,0.28);
//           display: flex; align-items: center; justify-content: center;
//           z-index: 4; transition: background 0.2s; cursor: pointer;
//         }
//         .play-overlay:hover { background: rgba(0,0,0,0.4); }

//         .play-btn {
//           width: 56px; height: 56px; border-radius: 50%;
//           background: var(--teal);
//           border: 3px solid rgba(255,255,255,0.25);
//           display: flex; align-items: center; justify-content: center;
//           cursor: pointer;
//           transition: transform 0.2s cubic-bezier(.22,.68,0,1.4), background 0.2s;
//           box-shadow: 0 4px 24px rgba(14,207,206,0.4);
//         }
//         .play-btn:hover { transform: scale(1.12); background: var(--teal-dark); }
//         .play-btn svg { margin-left: 3px; }

//         /* ── BADGES ── */
//         .badge {
//           position: absolute; top: 12px; left: 12px;
//           display: inline-flex; align-items: center; gap: 5px;
//           font-size: 11px; font-weight: 700; padding: 4px 10px;
//           border-radius: 100px; z-index: 5; letter-spacing: 0.2px;
//           font-family: 'Plus Jakarta Sans', sans-serif;
//           backdrop-filter: blur(8px);
//         }
//         .badge-preview {
//           background: rgba(14,207,206,0.18); color: #fff;
//           border: 1px solid rgba(14,207,206,0.4);
//         }
//         .badge-purchased {
//           background: rgba(34,197,94,0.18); color: #fff;
//           border: 1px solid rgba(34,197,94,0.4);
//         }

//         /* ── LOCK OVERLAY ── */
//         .lock-overlay {
//           position: absolute; inset: 0;
//           background: rgba(8,12,20,0.93);
//           backdrop-filter: blur(6px);
//           display: flex; flex-direction: column;
//           align-items: center; justify-content: center;
//           z-index: 10; padding: 24px 20px;
//           text-align: center; gap: 9px;
//           animation: csLockIn 0.22s ease;
//         }
//         @keyframes csLockIn {
//           from { opacity: 0; transform: scale(0.97); }
//           to   { opacity: 1; transform: scale(1); }
//         }
//         .lock-pulse-ring {
//           position: absolute; width: 90px; height: 90px;
//           border-radius: 50%; border: 1.5px solid rgba(14,207,206,0.22);
//           animation: lockPulse 2s ease-in-out infinite; pointer-events: none;
//         }
//         @keyframes lockPulse {
//           0%, 100% { transform: scale(1); opacity: 0.5; }
//           50% { transform: scale(1.35); opacity: 0; }
//         }
//         .lock-icon-wrap {
//           width: 58px; height: 58px; border-radius: 50%;
//           background: rgba(14,207,206,0.1);
//           border: 1.5px solid rgba(14,207,206,0.3);
//           display: flex; align-items: center; justify-content: center;
//           position: relative; z-index: 1;
//         }
//         .lock-title {
//           font-family: 'Plus Jakarta Sans', sans-serif;
//           font-size: 15px; font-weight: 800; color: #f1f5f9;
//           margin: 2px 0 0; letter-spacing: -0.2px;
//         }
//         .lock-sub {
//           font-size: 12px; color: #64748b; margin: 0;
//           line-height: 1.55; max-width: 200px;
//         }
//         .btn-lock-cart {
//           background: var(--teal); color: #fff; border: none;
//           border-radius: 10px; padding: 9px 22px;
//           font-size: 13px; font-weight: 700; cursor: pointer;
//           display: flex; align-items: center; gap: 7px;
//           transition: opacity 0.2s, transform 0.15s;
//           font-family: 'Plus Jakarta Sans', sans-serif;
//           letter-spacing: 0.1px; margin-top: 2px;
//         }
//         .btn-lock-cart:hover:not(:disabled) { opacity: 0.88; transform: translateY(-1px); }
//         .btn-lock-cart.added { background: #16a34a; cursor: default; }
//         .btn-lock-cart:disabled { opacity: 0.7; }
//         .btn-replay {
//           background: transparent; color: #475569;
//           border: 1px solid #2d3748; border-radius: 8px;
//           padding: 6px 14px; font-size: 11.5px; font-weight: 600;
//           cursor: pointer; display: flex; align-items: center; gap: 5px;
//           transition: color 0.2s, border-color 0.2s;
//           font-family: 'DM Sans', sans-serif;
//         }
//         .btn-replay:hover { color: #94a3b8; border-color: #475569; }

//         /* ── CARD BODY ── */
//         .card-body-inner {
//           padding: 18px 20px 20px;
//           display: flex; flex-direction: column; flex: 1; gap: 10px;
//         }
//         .card-title {
//           font-family: 'Plus Jakarta Sans', sans-serif;
//           font-size: 15.5px; font-weight: 700; color: var(--text-primary);
//           margin: 0; line-height: 1.4; letter-spacing: -0.2px;
//         }

//         /* ── HTML Content ── */
//         .html-content ul, .html-content ol {
//           padding-left: 20px; margin: 4px 0;
//         }
//         .html-content ul li, .html-content ol li {
//           color: var(--text-secondary); font-size: 13px;
//           margin-bottom: 3px; line-height: 1.6; list-style-type: disc;
//         }
//         .html-content ol li { list-style-type: decimal; }
//         .html-content p {
//           margin: 0 0 4px; color: var(--text-secondary);
//           font-size: 13px; line-height: 1.65;
//         }
//         .html-content strong { color: var(--text-primary); }
//         .html-content a { color: var(--teal); text-decoration: none; }

//         .card-desc { font-size: 13px; color: var(--text-secondary); line-height: 1.65; }
//         .card-details {
//           font-size: 12.5px; color: var(--text-muted);
//           line-height: 1.6; border-top: 1px solid #f1f5f9; padding-top: 10px;
//         }

//         /* ── PRICE ── */
//         .price-row { display: flex; align-items: baseline; gap: 10px; margin-top: 2px; }
//         .price-current {
//           font-family: 'Plus Jakarta Sans', sans-serif;
//           font-size: 21px; font-weight: 800; color: var(--green); letter-spacing: -0.5px;
//         }
//         .price-old {
//           font-size: 13.5px; color: var(--text-muted);
//           text-decoration: line-through; font-weight: 500;
//         }
//         .price-free {
//           font-family: 'Plus Jakarta Sans', sans-serif;
//           font-size: 16px; font-weight: 700; color: var(--teal);
//         }

//         /* ── NOT AVAILABLE TAG ── */
//         .no-prod-tag {
//           display: inline-flex; align-items: center; gap: 5px;
//           color: var(--text-muted); font-size: 12px; font-weight: 500;
//           padding: 8px 12px; border-radius: 8px;
//           background: #f8fafc; border: 1px dashed #e2e8f0;
//           font-family: 'DM Sans', sans-serif; margin-top: auto;
//         }

//         /* ── BUTTONS ── */
//         .btn-cart {
//           margin-top: auto; padding: 12px 0; border-radius: 12px;
//           border: 1.5px solid var(--teal); font-size: 13.5px; font-weight: 700;
//           cursor: pointer; background: transparent; color: var(--teal);
//           width: 100%; display: flex; align-items: center; justify-content: center;
//           gap: 7px; letter-spacing: 0.1px;
//           transition: background 0.2s, color 0.2s, transform 0.15s;
//           font-family: 'Plus Jakarta Sans', sans-serif;
//         }
//         .btn-cart:hover:not(:disabled):not(.added) {
//           background: var(--teal); color: #fff; transform: translateY(-1px);
//         }
//         .btn-cart.added {
//           background: #f0fdf4; border-color: var(--green); color: var(--green-dark); cursor: default;
//         }
//         .btn-cart:disabled:not(.added) { opacity: 0.65; cursor: not-allowed; }

//         .btn-watch {
//           margin-top: auto; padding: 12px 0; border-radius: 12px; border: none;
//           font-size: 13.5px; font-weight: 700; cursor: pointer;
//           background: linear-gradient(135deg, #22c55e, #16a34a); color: #fff;
//           width: 100%; display: flex; align-items: center; justify-content: center;
//           gap: 7px; transition: opacity 0.2s, transform 0.15s;
//           font-family: 'Plus Jakarta Sans', sans-serif; letter-spacing: 0.1px;
//         }
//         .btn-watch:hover { opacity: 0.9; transform: translateY(-1px); }

//         /* ── SPINNER ── */
//         .cs-spinner {
//           display: inline-block; width: 15px; height: 15px;
//           border: 2px solid rgba(255,255,255,0.3); border-top-color: #fff;
//           border-radius: 50%; animation: csSpin 0.7s linear infinite;
//         }
//         @keyframes csSpin { to { transform: rotate(360deg); } }

//         /* ── SKELETON ── */
//         .cs-skeleton-card {
//           background: white; border-radius: 20px;
//           overflow: hidden; border: 1.5px solid #f1f5f9;
//         }
//         .cs-skeleton {
//           background: linear-gradient(90deg, #f8fafc 25%, #f1f5f9 50%, #f8fafc 75%);
//           background-size: 200% 100%;
//           animation: csSkeleton 1.5s ease-in-out infinite; border-radius: 6px;
//         }
//         @keyframes csSkeleton {
//           0% { background-position: -200% 0; }
//           100% { background-position: 200% 0; }
//         }

//         @media (max-width: 600px) {
//           .cs-grid { padding: 0 12px; gap: 16px; }
//           .cs-heading { font-size: 1.7rem; }
//         }
//       `}</style>

//       <div className="cs-root">
//         <div className="container-fluid px-0">
//           <div className="cs-header">
//             <div className="cs-eyebrow">
//               <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polygon points="5,3 19,12 5,21" /></svg>
//               Video Courses
//             </div>
//             <h2 className="cs-heading">Learn From Industry Experts</h2>
//             <p className="cs-sub">Preview any course free · Unlock full access after purchase</p>
//           </div>

//           {loading && (
//             <div className="cs-grid">
//               {[1, 2, 3].map((n) => (
//                 <div key={n} className="cs-skeleton-card">
//                   <div className="cs-skeleton" style={{ height: 205, borderRadius: 0 }} />
//                   <div style={{ padding: "18px 20px 20px", display: "flex", flexDirection: "column", gap: 10 }}>
//                     <div className="cs-skeleton" style={{ height: 18, width: "85%" }} />
//                     <div className="cs-skeleton" style={{ height: 13, width: "70%" }} />
//                     <div className="cs-skeleton" style={{ height: 13, width: "55%" }} />
//                     <div className="cs-skeleton" style={{ height: 28, width: "40%", marginTop: 4 }} />
//                     <div className="cs-skeleton" style={{ height: 46, borderRadius: 12, marginTop: 8 }} />
//                   </div>
//                 </div>
//               ))}
//             </div>
//           )}

//           {error && (
//             <p style={{ textAlign: "center", color: "#ef4444", padding: 40 }}>{error}</p>
//           )}

//           {!loading && !error && (
//             <div className="cs-grid">
//               {videos.map((v) => renderCard(v))}
//             </div>
//           )}
//         </div>
//       </div>
//     </>
//   );
// };

// export default CourseSection2;


// 18feb with list list_video + list_get_product
// import React, { useEffect, useState, useRef } from "react";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";

// // const API_URL = "https://ecom.cyberathon.com/index.php/Api/list_video";
// const API_URL = "https://ecom.cyberathon.com/index.php/Api/list_get_product";
// const BASE_URL = "https://ecom.cyberathon.com/";
// const FREE_SECONDS = 10;

// // ─── Render HTML safely ──────────────────────────────────────────────────────
// const HtmlContent = ({ html, className = "", maxLines = null }) => {
//   if (!html) return null;
//   const style = maxLines
//     ? {
//         display: "-webkit-box",
//         WebkitLineClamp: maxLines,
//         WebkitBoxOrient: "vertical",
//         overflow: "hidden",
//       }
//     : {};
//   return (
//     <div
//       className={className}
//       style={style}
//       dangerouslySetInnerHTML={{ __html: html }}
//     />
//   );
// };

// // ─── YouTube API Loader ──────────────────────────────────────────────────────
// function loadYouTubeAPI() {
//   if (window.YT && window.YT.Player) return Promise.resolve();
//   if (window.__ytApiPromise) return window.__ytApiPromise;
//   window.__ytApiPromise = new Promise((resolve) => {
//     window.onYouTubeIframeAPIReady = resolve;
//     const tag = document.createElement("script");
//     tag.src = "https://www.youtube.com/iframe_api";
//     document.body.appendChild(tag);
//   });
//   return window.__ytApiPromise;
// }

// function getYouTubeId(embedUrl) {
//   if (!embedUrl) return "";
//   const match = embedUrl.match(/embed\/([^?&]+)/);
//   return match ? match[1] : "";
// }

// // ─── Detect video type ────────────────────────────────────────────────────────
// function detectVideoType(url) {
//   if (!url || url.trim() === "") return "no-video";
//   const u = url.toLowerCase();
//   if (u.includes("youtube.com") || u.includes("youtu.be")) return "youtube";
//   if (
//     u.endsWith(".mp4") ||
//     u.endsWith(".webm") ||
//     u.endsWith(".ogg") ||
//     u.includes(".mp4?") ||
//     u.includes("gtv-videos-bucket") ||
//     u.includes("commondatastorage.googleapis.com") ||
//     u.includes("archive.org")
//   )
//     return "mp4";
//   if (u.includes("vimeo.com") || u.includes("dailymotion.com")) return "iframe";
//   return "mp4";
// }

// function buildYouTubeEmbedUrl(raw) {
//   try {
//     if (raw.includes("watch?v=")) {
//       const id = new URLSearchParams(new URL(raw).search).get("v");
//       return `https://www.youtube.com/embed/${id}`;
//     }
//     if (raw.includes("youtu.be/")) {
//       const id = raw.split("youtu.be/")[1].split("?")[0];
//       return `https://www.youtube.com/embed/${id}`;
//     }
//     if (raw.includes("embed/")) return raw;
//   } catch (e) {}
//   return raw;
// }

// function buildVimeoEmbedUrl(raw) {
//   const match = raw.match(/vimeo\.com\/(\d+)/);
//   if (match) return `https://player.vimeo.com/video/${match[1]}?autoplay=1`;
//   return raw;
// }

// // ─── Add to Cart helper ──────────────────────────────────────────────────────
// async function addToCartApi(prod_id, onSuccess, onError) {
//   const userId = sessionStorage.getItem("userId");
//   if (!userId) {
//     alert("Please login first!");
//     return;
//   }
//   try {
//     const res = await axios.post(
//       "https://ecom.cyberathon.com/index.php/Api/insert_cart",
//       { user_id: Number(userId), prod_id: Number(prod_id), qty: 1 }
//     );
//     if (res.data.status === true) onSuccess();
//     else onError(res.data.message || "Failed to add");
//   } catch (e) {
//     console.error(e);
//     onError("Something went wrong");
//   }
// }

// // ─── No-video placeholder ─────────────────────────────────────────────────────
// const NoVideoPlaceholder = () => (
//   <div className="no-video-placeholder">
//     <svg width="38" height="38" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.25)" strokeWidth="1.4">
//       <rect x="2" y="2" width="20" height="20" rx="2.5" />
//       <path d="M10 8l6 4-6 4V8z" />
//       <line x1="2" y1="2" x2="22" y2="22" />
//     </svg>
//     <span>No Video Available</span>
//   </div>
// );

// // ─── Lock Overlay ─────────────────────────────────────────────────────────────
// const LockOverlay = ({ onReplay, prod_id, isAdded, onAddedChange }) => {
//   const [loading, setLoading] = useState(false);

//   const handleCart = async () => {
//     if (isAdded) return;
//     setLoading(true);
//     await addToCartApi(
//       prod_id,
//       () => { onAddedChange(true); setLoading(false); },
//       (msg) => { alert(msg); setLoading(false); }
//     );
//   };

//   return (
//     <div className="lock-overlay">
//       <div className="lock-pulse-ring" />
//       <div className="lock-icon-wrap">
//         <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
//           <rect x="3" y="11" width="18" height="11" rx="2" />
//           <path d="M7 11V7a5 5 0 0 1 10 0v4" />
//         </svg>
//       </div>
//       <p className="lock-title">Preview Ended</p>
//       <p className="lock-sub">Purchase this course to unlock full access</p>
//       {prod_id && (
//         <button
//           className={`btn-lock-cart${isAdded ? " added" : ""}`}
//           onClick={handleCart}
//           disabled={loading || isAdded}
//         >
//           {loading ? (
//             <span className="cs-spinner" />
//           ) : isAdded ? (
//             <><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="20 6 9 17 4 12" /></svg>Added to Cart</>
//           ) : (
//             <><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="9" cy="21" r="1" /><circle cx="20" cy="21" r="1" /><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" /></svg>Add to Cart</>
//           )}
//         </button>
//       )}
//       <button className="btn-replay" onClick={onReplay}>
//         <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2"><polyline points="1 4 1 10 7 10" /><path d="M3.51 15a9 9 0 1 0 .49-6" /></svg>
//         Watch Preview Again
//       </button>
//     </div>
//   );
// };

// // ─── Video Error Fallback ─────────────────────────────────────────────────────
// const VideoErrorFallback = ({ onRetry }) => (
//   <div className="video-error-fallback">
//     <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.3)" strokeWidth="1.5">
//       <circle cx="12" cy="12" r="10" />
//       <line x1="12" y1="8" x2="12" y2="12" />
//       <line x1="12" y1="16" x2="12.01" y2="16" />
//     </svg>
//     <span>Video could not be loaded</span>
//     {onRetry && <button className="btn-retry" onClick={onRetry}>Try Again</button>}
//   </div>
// );

// // ─── MP4 Card ─────────────────────────────────────────────────────────────────
// const Mp4VideoCard = ({ video, isPurchased, isAdded: initAdded, onCartChange, onNavigate }) => {
//   const [phase, setPhase] = useState("idle");
//   const [isAdded, setIsAdded] = useState(initAdded);
//   const [cartLoading, setCartLoading] = useState(false);
//   const videoRef = useRef(null);
//   const timerRef = useRef(null);

//   useEffect(() => { setIsAdded(initAdded); }, [initAdded]);
//   const handlePlay = () => setPhase("playing");

//   useEffect(() => {
//     if (phase !== "playing") return;
//     const vid = videoRef.current;
//     if (!vid || isPurchased) return;
//     const onPlay = () => {
//       timerRef.current = setTimeout(() => { vid.pause(); setPhase("locked"); }, FREE_SECONDS * 1000);
//     };
//     vid.addEventListener("play", onPlay);
//     return () => { vid.removeEventListener("play", onPlay); clearTimeout(timerRef.current); };
//   }, [phase, isPurchased]);

//   const handleReplay = () => { clearTimeout(timerRef.current); setPhase("idle"); };
//   const handleAddedChange = (val) => { setIsAdded(val); if (onCartChange) onCartChange(video.prod_id, val); };
//   const handleCartClick = async () => {
//     if (isAdded) return;
//     setCartLoading(true);
//     await addToCartApi(video.prod_id,
//       () => { setIsAdded(true); if (onCartChange) onCartChange(video.prod_id, true); setCartLoading(false); },
//       (msg) => { alert(msg); setCartLoading(false); }
//     );
//   };

//   return (
//     <div className="course-card">
//       <div className="video-area">
//         {isPurchased
//           ? <span className="badge badge-purchased"><svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3"><polyline points="20 6 9 17 4 12" /></svg>Purchased</span>
//           : <span className="badge badge-preview"><svg width="10" height="10" viewBox="0 0 24 24" fill="currentColor"><polygon points="5,3 19,12 5,21" /></svg>{FREE_SECONDS}s Free Preview</span>
//         }
//         {phase === "idle" && (
//           <>
//             <video src={`${video.embedUrl}#t=0.5`} style={{ width: "100%", height: "100%", objectFit: "cover" }} preload="metadata" muted playsInline />
//             <div className="play-overlay">
//               <button className="play-btn" onClick={handlePlay}>
//                 <svg width="20" height="20" viewBox="0 0 24 24" fill="white"><polygon points="5,3 19,12 5,21" /></svg>
//               </button>
//             </div>
//           </>
//         )}
//         {(phase === "playing" || phase === "locked") && (
//           <>
//             <video ref={videoRef} src={video.embedUrl} controls={isPurchased} autoPlay playsInline onError={() => setPhase("error")} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
//             {phase === "locked" && <LockOverlay onReplay={handleReplay} prod_id={video.prod_id} isAdded={isAdded} onAddedChange={handleAddedChange} />}
//           </>
//         )}
//         {phase === "error" && <VideoErrorFallback onRetry={() => setPhase("idle")} />}
//       </div>
//       <CardBody video={video} isPurchased={isPurchased} isAdded={isAdded} cartLoading={cartLoading} onWatch={handlePlay} onCart={handleCartClick} onNavigate={onNavigate} />
//     </div>
//   );
// };

// // ─── YouTube Card ─────────────────────────────────────────────────────────────
// const YoutubeVideoCard = ({ video, isPurchased, isAdded: initAdded, onCartChange, onNavigate }) => {
//   const [phase, setPhase] = useState("thumbnail");
//   const [isAdded, setIsAdded] = useState(initAdded);
//   const [cartLoading, setCartLoading] = useState(false);
//   const timerRef = useRef(null);
//   const playerRef = useRef(null);
//   const divId = `yt-player-${video.id}`;
//   const videoId = getYouTubeId(video.embedUrl);
//   const thumbUrl = videoId ? `https://img.youtube.com/vi/${videoId}/hqdefault.jpg` : null;

//   useEffect(() => { setIsAdded(initAdded); }, [initAdded]);

//   const handlePlay = async () => {
//     setPhase("playing");
//     await loadYouTubeAPI();
//     setTimeout(() => {
//       playerRef.current = new window.YT.Player(divId, {
//         events: {
//           onReady: (e) => {
//             e.target.playVideo();
//             if (!isPurchased) {
//               timerRef.current = setTimeout(() => { e.target.pauseVideo(); setPhase("locked"); }, FREE_SECONDS * 1000);
//             }
//           },
//         },
//       });
//     }, 300);
//   };

//   const handleReplay = () => {
//     clearTimeout(timerRef.current);
//     if (playerRef.current) { try { playerRef.current.destroy(); } catch (e) {} playerRef.current = null; }
//     setPhase("thumbnail");
//   };

//   useEffect(() => () => {
//     clearTimeout(timerRef.current);
//     if (playerRef.current) { try { playerRef.current.destroy(); } catch (e) {} }
//   }, []);

//   const handleAddedChange = (val) => { setIsAdded(val); if (onCartChange) onCartChange(video.prod_id, val); };
//   const handleCartClick = async () => {
//     if (isAdded) return;
//     setCartLoading(true);
//     await addToCartApi(video.prod_id,
//       () => { setIsAdded(true); if (onCartChange) onCartChange(video.prod_id, true); setCartLoading(false); },
//       (msg) => { alert(msg); setCartLoading(false); }
//     );
//   };

//   return (
//     <div className="course-card">
//       <div className="video-area">
//         {isPurchased
//           ? <span className="badge badge-purchased"><svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3"><polyline points="20 6 9 17 4 12" /></svg>Purchased</span>
//           : <span className="badge badge-preview"><svg width="10" height="10" viewBox="0 0 24 24" fill="currentColor"><polygon points="5,3 19,12 5,21" /></svg>{FREE_SECONDS}s Free Preview</span>
//         }
//         {phase === "thumbnail" && (
//           <>
//             {thumbUrl
//               ? <img src={thumbUrl} alt={video.heading} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
//               : <div style={{ width: "100%", height: "100%", background: "#0d1117" }} />
//             }
//             <div className="play-overlay">
//               <button className="play-btn" onClick={handlePlay}>
//                 <svg width="20" height="20" viewBox="0 0 24 24" fill="white"><polygon points="5,3 19,12 5,21" /></svg>
//               </button>
//             </div>
//           </>
//         )}
//         {(phase === "playing" || phase === "locked") && (
//           <>
//             <iframe id={divId} src={`https://www.youtube.com/embed/${videoId}?enablejsapi=1`} title={video.heading} allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen style={{ width: "100%", height: "100%", border: "none" }} />
//             {phase === "locked" && <LockOverlay onReplay={handleReplay} prod_id={video.prod_id} isAdded={isAdded} onAddedChange={handleAddedChange} />}
//           </>
//         )}
//       </div>
//       <CardBody video={video} isPurchased={isPurchased} isAdded={isAdded} cartLoading={cartLoading} onWatch={handlePlay} onCart={handleCartClick} onNavigate={onNavigate} />
//     </div>
//   );
// };

// // ─── IFrame Card ──────────────────────────────────────────────────────────────
// const IframeVideoCard = ({ video, isPurchased, isAdded: initAdded, onCartChange, onNavigate }) => {
//   const [phase, setPhase] = useState("thumbnail");
//   const [isAdded, setIsAdded] = useState(initAdded);
//   const [cartLoading, setCartLoading] = useState(false);
//   const timerRef = useRef(null);

//   useEffect(() => { setIsAdded(initAdded); }, [initAdded]);
//   const handlePlay = () => {
//     setPhase("playing");
//     if (!isPurchased) timerRef.current = setTimeout(() => setPhase("locked"), FREE_SECONDS * 1000);
//   };
//   const handleReplay = () => { clearTimeout(timerRef.current); setPhase("thumbnail"); };
//   useEffect(() => () => clearTimeout(timerRef.current), []);

//   const handleAddedChange = (val) => { setIsAdded(val); if (onCartChange) onCartChange(video.prod_id, val); };
//   const handleCartClick = async () => {
//     if (isAdded) return;
//     setCartLoading(true);
//     await addToCartApi(video.prod_id,
//       () => { setIsAdded(true); if (onCartChange) onCartChange(video.prod_id, true); setCartLoading(false); },
//       (msg) => { alert(msg); setCartLoading(false); }
//     );
//   };

//   const iframeSrc = video.embedUrl.includes("vimeo") ? buildVimeoEmbedUrl(video.embedUrl) : video.embedUrl;

//   return (
//     <div className="course-card">
//       <div className="video-area">
//         {isPurchased
//           ? <span className="badge badge-purchased"><svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3"><polyline points="20 6 9 17 4 12" /></svg>Purchased</span>
//           : <span className="badge badge-preview"><svg width="10" height="10" viewBox="0 0 24 24" fill="currentColor"><polygon points="5,3 19,12 5,21" /></svg>{FREE_SECONDS}s Free Preview</span>
//         }
//         {phase === "thumbnail" && (
//           <div className="play-overlay" style={{ background: "rgba(0,0,0,0.55)" }}>
//             <button className="play-btn" onClick={handlePlay}>
//               <svg width="20" height="20" viewBox="0 0 24 24" fill="white"><polygon points="5,3 19,12 5,21" /></svg>
//             </button>
//           </div>
//         )}
//         {(phase === "playing" || phase === "locked") && (
//           <>
//             <iframe src={iframeSrc} title={video.heading} allow="autoplay; fullscreen" allowFullScreen style={{ width: "100%", height: "100%", border: "none" }} />
//             {phase === "locked" && <LockOverlay onReplay={handleReplay} prod_id={video.prod_id} isAdded={isAdded} onAddedChange={handleAddedChange} />}
//           </>
//         )}
//       </div>
//       <CardBody video={video} isPurchased={isPurchased} isAdded={isAdded} cartLoading={cartLoading} onWatch={handlePlay} onCart={handleCartClick} onNavigate={onNavigate} />
//     </div>
//   );
// };

// // ─── No Video Card ────────────────────────────────────────────────────────────
// const NoVideoCard = ({ video, isPurchased, isAdded: initAdded, onCartChange, onNavigate }) => {
//   const [isAdded, setIsAdded] = useState(initAdded);
//   const [cartLoading, setCartLoading] = useState(false);

//   useEffect(() => { setIsAdded(initAdded); }, [initAdded]);
//   const handleCartClick = async () => {
//     if (isAdded) return;
//     setCartLoading(true);
//     await addToCartApi(video.prod_id,
//       () => { setIsAdded(true); if (onCartChange) onCartChange(video.prod_id, true); setCartLoading(false); },
//       (msg) => { alert(msg); setCartLoading(false); }
//     );
//   };

//   return (
//     <div className="course-card">
//       <div className="video-area">
//         {isPurchased && <span className="badge badge-purchased"><svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3"><polyline points="20 6 9 17 4 12" /></svg>Purchased</span>}
//         <NoVideoPlaceholder />
//       </div>
//       <CardBody video={video} isPurchased={isPurchased} isAdded={isAdded} cartLoading={cartLoading} onWatch={null} onCart={handleCartClick} onNavigate={onNavigate} />
//     </div>
//   );
// };

// // ─── Shared Card Body ─────────────────────────────────────────────────────────
// const CardBody = ({ video, isPurchased, isAdded, cartLoading, onWatch, onCart, onNavigate }) => (
//   <div className="card-body-inner">
//     {/* Title click → detail page */}
//     <h3
//       className="card-title"
//       style={{ cursor: onNavigate ? "pointer" : "default" }}
//       onClick={onNavigate}
//     >
//       {video.heading}
//     </h3>

//     {video.description && (
//       <div className="card-desc html-content">
//         <HtmlContent html={video.description} maxLines={3} />
//       </div>
//     )}

//     {/* {video.details && (
//       <div className="card-details html-content">
//         <HtmlContent html={video.details} maxLines={2} />
//       </div>
//     )} */}

//     <div className="price-row">
//       {video.current_price && Number(video.current_price) > 0 ? (
//         <>
//           <span className="price-current">₹{Number(video.current_price).toLocaleString("en-IN")}</span>
//           {video.old_price && Number(video.old_price) > 0 && (
//             <span className="price-old">₹{Number(video.old_price).toLocaleString("en-IN")}</span>
//           )}
//         </>
//       ) : (
//         <span className="price-free">Free</span>
//       )}
//     </div>

//     {/* No prod_id → not for sale */}
//     {!video.prod_id ? (
//       <div className="no-prod-tag">
//         <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" /></svg>
//         Not available for purchase
//       </div>
//     ) : isPurchased ? (
//       <div style={{ display: "flex", flexDirection: "column", gap: 8, marginTop: "auto" }}>
//         {onWatch && (
//           <button className="btn-watch" onClick={onWatch}>
//             <svg width="14" height="14" viewBox="0 0 24 24" fill="white"><polygon points="5,3 19,12 5,21" /></svg>
//             Watch Full Course
//           </button>
//         )}
//         {onNavigate && (
//           <button className="btn-view-details" onClick={onNavigate}>
//             View Course Details
//             <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2"><polyline points="9 18 15 12 9 6" /></svg>
//           </button>
//         )}
//       </div>
//     ) : (
//       <div style={{ display: "flex", flexDirection: "column", gap: 8, marginTop: "auto" }}>
//         <button
//           className={`btn-cart${isAdded ? " added" : ""}`}
//           onClick={onCart}
//           disabled={cartLoading || isAdded}
//         >
//           {cartLoading ? (
//             <span className="cs-spinner" />
//           ) : isAdded ? (
//             <><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="20 6 9 17 4 12" /></svg>Added to Cart</>
//           ) : (
//             <><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="9" cy="21" r="1" /><circle cx="20" cy="21" r="1" /><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" /></svg>Add to Cart</>
//           )}
//         </button>
//         {onNavigate && (
//           <button className="btn-view-details" onClick={onNavigate}>
//             View Course Details
//             <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2"><polyline points="9 18 15 12 9 6" /></svg>
//           </button>
//         )}
//       </div>
//     )}
//   </div>
// );

// // ─── MAIN COMPONENT ───────────────────────────────────────────────────────────
// const CourseSection2 = () => {
//   const navigate = useNavigate();

//   const [videos, setVideos] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");
//   const [purchasedProdIds, setPurchasedProdIds] = useState(new Set());
//   const [cartProdIds, setCartProdIds] = useState(new Set());

//   // useEffect(() => {
//   //   const load = async () => {
//   //     try {
//   //       const res = await axios.get(API_URL);
//   //       if (!res.data.status) { setError("No videos found"); return; }
//   //       const list = res.data.videos.map((v) => {
//   //         let rawUrl = v.video || "";
//   //         if (rawUrl && !rawUrl.startsWith("http")) rawUrl = BASE_URL + rawUrl;
//   //         const type = detectVideoType(rawUrl);
//   //         let embedUrl = rawUrl;
//   //         if (type === "youtube") embedUrl = buildYouTubeEmbedUrl(rawUrl);
//   //         return { ...v, type, embedUrl };
//   //       });
//   //       setVideos(list);
//   //     } catch (e) {
//   //       setError("Failed to fetch videos");
//   //     } finally {
//   //       setLoading(false);
//   //     }
//   //   };
//   //   load();
//   // }, []);

// //   useEffect(() => {
// //   const load = async () => {
// //     try {
// //       const res = await axios.get(API_URL);

// //       // ❌ agar status false hai
// //       if (!res.data.status) {
// //         setError("No products found");
// //         return;
// //       }

// //       // ✅ products ko map karo (IMPORTANT CHANGE)
// //       const list = res.data.products
// //         .filter((p) => p.product_type === "coursesection") // 👈 only courses
// //         .map((p) => {
// //           let rawUrl = p.video || "";

// //           // ✅ relative URL ko full URL banao
// //           if (rawUrl && !rawUrl.startsWith("http")) {
// //             rawUrl = BASE_URL + rawUrl;
// //           }

// //           // ✅ video type detect
// //           const type = detectVideoType(rawUrl);

// //           let embedUrl = rawUrl;

// //           // ✅ youtube fix
// //           if (type === "youtube") {
// //             embedUrl = buildYouTubeEmbedUrl(rawUrl);
// //           }

// //           return {
// //             id: p.id,
// //             prod_id: p.prod_id,

// //             // ✅ UI mapping (VERY IMPORTANT)
// //             heading: p.product_name,
// //             description: p.description,

// //             current_price: p.price,
// //             old_price: p.old_price,

// //             embedUrl,
// //             type,
// //           };
// //         });

// //       setVideos(list);

// //     } catch (e) {
// //       console.error(e);
// //       setError("Failed to fetch products");
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   load();
// // }, []);

// useEffect(() => {
//   const load = async () => {
//     try {
//       const res = await axios.get(API_URL);

//       if (!res.data?.status) {
//         setError("No products found");
//         return;
//       }

//       const products = Array.isArray(res.data.products) ? res.data.products : [];

//       const list = products
//         .filter((p) => p.product_type && p.product_type.toLowerCase() === "coursesection")
//         .map((p) => {
//           let rawUrl = p.video || p.video_url || p.product_video || "";

//           // full URL fix
//           if (rawUrl && !rawUrl.startsWith("http")) {
//             rawUrl = BASE_URL + rawUrl;
//           }

//           const type = detectVideoType(rawUrl);

//           let embedUrl = rawUrl;

//           if (type === "youtube") {
//             embedUrl = buildYouTubeEmbedUrl(rawUrl);
//           }

//           return {
//             id: p.id,
//             prod_id: p.prod_id,

//             heading: p.product_name || p.title || p.heading || "Untitled Course",
//             description: p.description || "",

//             current_price: p.price || 0,
//             old_price: p.old_price || 0,

//             embedUrl,
//             type,
//           };
//         });

//       setVideos(list);

//     } catch (e) {
//       console.error("API Error:", e);
//       setError("Failed to fetch products");
//     } finally {
//       setLoading(false);
//     }
//   };

//   load();
// }, []);

//   useEffect(() => {
//     const init = async () => {
//       const userId = sessionStorage.getItem("userId");
//       const cartToken = localStorage.getItem("cart_token");

//       if (userId || cartToken) {
//         try {
//           const res = await axios.post("https://ecom.cyberathon.com/index.php/Api/list_cart", {
//             user_id: userId || null,
//             cart_token: userId ? null : cartToken,
//           });
//           if (res.data.status) {
//             setCartProdIds(new Set(res.data.cart_items.map((i) => String(i.prod_id))));
//           }
//         } catch (e) { console.error(e); }
//       }

//       if (userId) {
//         try {
//           const res = await axios.post("https://ecom.cyberathon.com/index.php/Api/list_new_order", {
//             user_id: parseInt(userId),
//           });
//           if (res.data.status && Array.isArray(res.data.orders)) {
//             const ids = new Set();
//             res.data.orders.forEach((order) => {
//               if (!Array.isArray(order.items)) return;
//               order.items.forEach((item) => {
//                 if (!item.prod_id) return;
//                 if (
//                   item.access === "unlocked" ||
//                   order.purchase_status === "yes" ||
//                   order.payment_status === "Paid" ||
//                   order.payment_status === "paid" ||
//                   order.order_status === "Delivered" ||
//                   order.order_status === "Completed"
//                 ) {
//                   ids.add(String(item.prod_id));
//                 }
//               });
//             });
//             setPurchasedProdIds(ids);
//           }
//         } catch (e) { console.error(e); }
//       }
//     };
//     init();
//   }, []);

//   const handleCartChange = (prod_id, added) => {
//     setCartProdIds((prev) => {
//       const next = new Set(prev);
//       if (added) next.add(String(prod_id));
//       else next.delete(String(prod_id));
//       return next;
//     });
//   };

//   const renderCard = (v) => {
//     const strId = String(v.prod_id);
//     const isPurchased = purchasedProdIds.has(strId);
//     const isAdded = cartProdIds.has(strId);
//     const props = {
//       key: v.id,
//       video: v,
//       isPurchased,
//       isAdded,
//       onCartChange: handleCartChange,
//       // ✅ Matches App.jsx route: /coursesectiondetail/:id
//       onNavigate: () => navigate(`/coursesectiondetail/${v.id}`),
//     };

//     switch (v.type) {
//       case "youtube":  return <YoutubeVideoCard {...props} />;
//       case "mp4":      return <Mp4VideoCard {...props} />;
//       case "iframe":   return <IframeVideoCard {...props} />;
//       case "no-video": return <NoVideoCard {...props} />;
//       default:         return <Mp4VideoCard {...props} />;
//     }
//   };

//   return (
//     <>
//       <style>{`
//         @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&family=DM+Sans:wght@400;500;600&display=swap');

//         :root {
//           --teal: #0ecfce;
//           --teal-dark: #0ab5b4;
//           --green: #22c55e;
//           --green-dark: #16a34a;
//           --card-bg: #ffffff;
//           --card-border: #e5f0f0;
//           --card-hover-border: #0ecfce;
//           --text-primary: #0f172a;
//           --text-secondary: #475569;
//           --text-muted: #94a3b8;
//           --surface: #f7fffe;
//         }

//         .cs-root {
//           background: var(--surface);
//           min-height: 60vh;
//           padding: 64px 0 80px;
//           font-family: 'DM Sans', sans-serif;
//         }

//         .cs-header { text-align: center; margin-bottom: 52px; padding: 0 16px; }
//         .cs-eyebrow {
//           display: inline-flex; align-items: center; gap: 6px;
//           background: rgba(14,207,206,0.1); color: #0891b2;
//           font-size: 11.5px; font-weight: 700; letter-spacing: 1px;
//           text-transform: uppercase; padding: 5px 14px;
//           border-radius: 100px; margin-bottom: 16px;
//           font-family: 'Plus Jakarta Sans', sans-serif;
//         }
//         .cs-heading {
//           font-family: 'Plus Jakarta Sans', sans-serif;
//           font-size: clamp(1.9rem, 3.5vw, 2.8rem); font-weight: 800;
//           color: var(--text-primary); margin: 0 0 10px;
//           letter-spacing: -0.8px; line-height: 1.15;
//         }
//         .cs-sub { color: var(--text-muted); font-size: 15px; margin: 0; }

//         .cs-grid {
//           display: grid;
//           grid-template-columns: repeat(auto-fill, minmax(310px, 1fr));
//           gap: 24px; padding: 0 24px;
//           max-width: 1240px; margin: 0 auto;
//         }

//         .course-card {
//           background: var(--card-bg);
//           border: 1.5px solid var(--card-border);
//           border-radius: 20px; overflow: hidden;
//           display: flex; flex-direction: column;
//           transition: transform 0.28s cubic-bezier(.22,.68,0,1.2), box-shadow 0.28s ease, border-color 0.2s ease;
//           animation: csCardIn 0.45s ease both;
//           position: relative;
//         }
//         .course-card:hover {
//           transform: translateY(-7px);
//           box-shadow: 0 20px 52px rgba(14,207,206,0.12), 0 4px 16px rgba(0,0,0,0.05);
//           border-color: var(--card-hover-border);
//         }
//         @keyframes csCardIn {
//           from { opacity: 0; transform: translateY(22px); }
//           to   { opacity: 1; transform: translateY(0); }
//         }

//         .video-area {
//           position: relative; width: 100%; height: 205px;
//           background: #0d1117; overflow: hidden; flex-shrink: 0;
//         }
//         .video-area img, .video-area video, .video-area iframe {
//           width: 100%; height: 100%; object-fit: cover; display: block;
//         }

//         .no-video-placeholder {
//           width: 100%; height: 100%;
//           display: flex; flex-direction: column;
//           align-items: center; justify-content: center;
//           gap: 10px; background: #0d1117;
//         }
//         .no-video-placeholder span {
//           font-size: 12px; color: rgba(255,255,255,0.2);
//           font-family: 'DM Sans', sans-serif;
//         }

//         .video-error-fallback {
//           width: 100%; height: 100%;
//           display: flex; flex-direction: column;
//           align-items: center; justify-content: center;
//           gap: 10px; background: #0d1117; padding: 20px; text-align: center;
//         }
//         .video-error-fallback span { font-size: 12px; color: rgba(255,255,255,0.25); font-family: 'DM Sans', sans-serif; }
//         .btn-retry {
//           background: rgba(14,207,206,0.12); color: var(--teal);
//           border: 1px solid rgba(14,207,206,0.3); border-radius: 8px;
//           padding: 5px 14px; font-size: 11.5px; font-weight: 600;
//           cursor: pointer; font-family: 'DM Sans', sans-serif; transition: background 0.2s;
//         }
//         .btn-retry:hover { background: rgba(14,207,206,0.2); }

//         .play-overlay {
//           position: absolute; inset: 0;
//           background: rgba(0,0,0,0.28);
//           display: flex; align-items: center; justify-content: center;
//           z-index: 4; transition: background 0.2s; cursor: pointer;
//         }
//         .play-overlay:hover { background: rgba(0,0,0,0.4); }

//         .play-btn {
//           width: 56px; height: 56px; border-radius: 50%;
//           background: var(--teal); border: 3px solid rgba(255,255,255,0.25);
//           display: flex; align-items: center; justify-content: center;
//           cursor: pointer;
//           transition: transform 0.2s cubic-bezier(.22,.68,0,1.4), background 0.2s;
//           box-shadow: 0 4px 24px rgba(14,207,206,0.4);
//         }
//         .play-btn:hover { transform: scale(1.12); background: var(--teal-dark); }
//         .play-btn svg { margin-left: 3px; }

//         .badge {
//           position: absolute; top: 12px; left: 12px;
//           display: inline-flex; align-items: center; gap: 5px;
//           font-size: 11px; font-weight: 700; padding: 4px 10px;
//           border-radius: 100px; z-index: 5; letter-spacing: 0.2px;
//           font-family: 'Plus Jakarta Sans', sans-serif; backdrop-filter: blur(8px);
//         }
//         .badge-preview { background: rgba(14,207,206,0.18); color: #fff; border: 1px solid rgba(14,207,206,0.4); }
//         .badge-purchased { background: rgba(34,197,94,0.18); color: #fff; border: 1px solid rgba(34,197,94,0.4); }

//         .lock-overlay {
//           position: absolute; inset: 0;
//           background: rgba(8,12,20,0.93); backdrop-filter: blur(6px);
//           display: flex; flex-direction: column;
//           align-items: center; justify-content: center;
//           z-index: 10; padding: 24px 20px; text-align: center; gap: 9px;
//           animation: csLockIn 0.22s ease;
//         }
//         @keyframes csLockIn { from { opacity: 0; transform: scale(0.97); } to { opacity: 1; transform: scale(1); } }
//         .lock-pulse-ring {
//           position: absolute; width: 90px; height: 90px; border-radius: 50%;
//           border: 1.5px solid rgba(14,207,206,0.22);
//           animation: lockPulse 2s ease-in-out infinite; pointer-events: none;
//         }
//         @keyframes lockPulse { 0%, 100% { transform: scale(1); opacity: 0.5; } 50% { transform: scale(1.35); opacity: 0; } }
//         .lock-icon-wrap {
//           width: 58px; height: 58px; border-radius: 50%;
//           background: rgba(14,207,206,0.1); border: 1.5px solid rgba(14,207,206,0.3);
//           display: flex; align-items: center; justify-content: center;
//           position: relative; z-index: 1;
//         }
//         .lock-title { font-family: 'Plus Jakarta Sans', sans-serif; font-size: 15px; font-weight: 800; color: #f1f5f9; margin: 2px 0 0; }
//         .lock-sub { font-size: 12px; color: #64748b; margin: 0; line-height: 1.55; max-width: 200px; }
//         .btn-lock-cart {
//           background: var(--teal); color: #fff; border: none; border-radius: 10px;
//           padding: 9px 22px; font-size: 13px; font-weight: 700; cursor: pointer;
//           display: flex; align-items: center; gap: 7px;
//           transition: opacity 0.2s, transform 0.15s;
//           font-family: 'Plus Jakarta Sans', sans-serif; margin-top: 2px;
//         }
//         .btn-lock-cart:hover:not(:disabled) { opacity: 0.88; transform: translateY(-1px); }
//         .btn-lock-cart.added { background: #16a34a; cursor: default; }
//         .btn-lock-cart:disabled { opacity: 0.7; }
//         .btn-replay {
//           background: transparent; color: #475569; border: 1px solid #2d3748;
//           border-radius: 8px; padding: 6px 14px; font-size: 11.5px; font-weight: 600;
//           cursor: pointer; display: flex; align-items: center; gap: 5px;
//           transition: color 0.2s, border-color 0.2s; font-family: 'DM Sans', sans-serif;
//         }
//         .btn-replay:hover { color: #94a3b8; border-color: #475569; }

//         .card-body-inner { padding: 18px 20px 20px; display: flex; flex-direction: column; flex: 1; gap: 10px; }
//         .card-title {
//           font-family: 'Plus Jakarta Sans', sans-serif;
//           font-size: 15.5px; font-weight: 700; color: var(--text-primary);
//           margin: 0; line-height: 1.4; letter-spacing: -0.2px; transition: color 0.15s;
//         }
//         .card-title:hover { color: var(--teal); }

//         .html-content ul, .html-content ol { padding-left: 20px; margin: 4px 0; }
//         .html-content ul li, .html-content ol li { color: var(--text-secondary); font-size: 13px; margin-bottom: 3px; line-height: 1.6; list-style-type: disc; }
//         .html-content ol li { list-style-type: decimal; }
//         .html-content p { margin: 0 0 4px; color: var(--text-secondary); font-size: 13px; line-height: 1.65; }
//         .html-content strong { color: var(--text-primary); }
//         .html-content a { color: var(--teal); text-decoration: none; }

//         .card-desc { font-size: 13px; color: var(--text-secondary); line-height: 1.65; }
//         .card-details { font-size: 12.5px; color: var(--text-muted); line-height: 1.6; border-top: 1px solid #f1f5f9; padding-top: 10px; }

//         .price-row { display: flex; align-items: baseline; gap: 10px; margin-top: 2px; }
//         .price-current { font-family: 'Plus Jakarta Sans', sans-serif; font-size: 21px; font-weight: 800; color: var(--green); letter-spacing: -0.5px; }
//         .price-old { font-size: 13.5px; color: var(--text-muted); text-decoration: line-through; font-weight: 500; }
//         .price-free { font-family: 'Plus Jakarta Sans', sans-serif; font-size: 16px; font-weight: 700; color: var(--teal); }

//         .no-prod-tag {
//           display: inline-flex; align-items: center; gap: 5px;
//           color: var(--text-muted); font-size: 12px; font-weight: 500;
//           padding: 8px 12px; border-radius: 8px;
//           background: #f8fafc; border: 1px dashed #e2e8f0;
//           font-family: 'DM Sans', sans-serif; margin-top: auto;
//         }

//         .btn-cart {
//           padding: 12px 0; border-radius: 12px;
//           border: 1.5px solid var(--teal); font-size: 13.5px; font-weight: 700;
//           cursor: pointer; background: transparent; color: var(--teal);
//           width: 100%; display: flex; align-items: center; justify-content: center;
//           gap: 7px; letter-spacing: 0.1px;
//           transition: background 0.2s, color 0.2s, transform 0.15s;
//           font-family: 'Plus Jakarta Sans', sans-serif;
//         }
//         .btn-cart:hover:not(:disabled):not(.added) { background: var(--teal); color: #fff; transform: translateY(-1px); }
//         .btn-cart.added { background: #f0fdf4; border-color: var(--green); color: var(--green-dark); cursor: default; }
//         .btn-cart:disabled:not(.added) { opacity: 0.65; cursor: not-allowed; }

//         .btn-watch {
//           padding: 12px 0; border-radius: 12px; border: none;
//           font-size: 13.5px; font-weight: 700; cursor: pointer;
//           background: linear-gradient(135deg, #22c55e, #16a34a); color: #fff;
//           width: 100%; display: flex; align-items: center; justify-content: center;
//           gap: 7px; transition: opacity 0.2s, transform 0.15s;
//           font-family: 'Plus Jakarta Sans', sans-serif;
//         }
//         .btn-watch:hover { opacity: 0.9; transform: translateY(-1px); }

//         .btn-view-details {
//           padding: 9px 0; border-radius: 10px;
//           border: 1px solid var(--card-border);
//           font-size: 13px; font-weight: 600;
//           cursor: pointer; background: #f8fffe; color: var(--teal);
//           width: 100%; display: flex; align-items: center; justify-content: center;
//           gap: 5px; transition: background 0.2s, border-color 0.2s;
//           font-family: 'Plus Jakarta Sans', sans-serif;
//         }
//         .btn-view-details:hover { background: rgba(14,207,206,0.06); border-color: var(--teal); }

//         .cs-spinner {
//           display: inline-block; width: 15px; height: 15px;
//           border: 2px solid rgba(255,255,255,0.3); border-top-color: #fff;
//           border-radius: 50%; animation: csSpin 0.7s linear infinite;
//         }
//         @keyframes csSpin { to { transform: rotate(360deg); } }

//         .cs-skeleton-card { background: white; border-radius: 20px; overflow: hidden; border: 1.5px solid #f1f5f9; }
//         .cs-skeleton {
//           background: linear-gradient(90deg, #f8fafc 25%, #f1f5f9 50%, #f8fafc 75%);
//           background-size: 200% 100%; animation: csSkeleton 1.5s ease-in-out infinite; border-radius: 6px;
//         }
//         @keyframes csSkeleton { 0% { background-position: -200% 0; } 100% { background-position: 200% 0; } }

//         @media (max-width: 600px) {
//           .cs-grid { padding: 0 12px; gap: 16px; }
//           .cs-heading { font-size: 1.7rem; }
//         }
//       `}</style>

//       <div className="cs-root">
//         <div className="container-fluid px-0">
//           <h1 className="text-center fw-bold text-bold pb-5">Our Courses</h1>

//           {loading && (
//             <div className="cs-grid">
//               {[1, 2, 3].map((n) => (
//                 <div key={n} className="cs-skeleton-card">
//                   <div className="cs-skeleton" style={{ height: 205, borderRadius: 0 }} />
//                   <div style={{ padding: "18px 20px 20px", display: "flex", flexDirection: "column", gap: 10 }}>
//                     <div className="cs-skeleton" style={{ height: 18, width: "85%" }} />
//                     <div className="cs-skeleton" style={{ height: 13, width: "70%" }} />
//                     <div className="cs-skeleton" style={{ height: 13, width: "55%" }} />
//                     <div className="cs-skeleton" style={{ height: 28, width: "40%", marginTop: 4 }} />
//                     <div className="cs-skeleton" style={{ height: 46, borderRadius: 12, marginTop: 8 }} />
//                   </div>
//                 </div>
//               ))}
//             </div>
//           )}

//           {error && (
//             <p style={{ textAlign: "center", color: "#ef4444", padding: 40 }}>{error}</p>
//           )}

//           {!loading && !error && (
//             <div className="cs-grid">
//               {videos.map((v) => renderCard(v))}
//             </div>
//           )}
//         </div>
//       </div>
//     </>
//   );
// };

// export default CourseSection2;

import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const API_URL = "https://ecom.cyberathon.com/index.php/Api/list_get_product";
const BASE_URL = "https://ecom.cyberathon.com/";
const FREE_SECONDS = 10;
const getCartToken = () => {
  let token = localStorage.getItem("cart_token");
  if (!token) {
    token = crypto.randomUUID();
    localStorage.setItem("cart_token", token);
  }
  return token;
};

// ─── Render HTML safely ──────────────────────────────────────────────────────
const HtmlContent = ({ html, className = "", maxLines = null }) => {
  if (!html) return null;
  const style = maxLines
    ? {
        display: "-webkit-box",
        WebkitLineClamp: maxLines,
        WebkitBoxOrient: "vertical",
        overflow: "hidden",
      }
    : {};
  return (
    <div
      className={className}
      style={style}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
};

// ─── YouTube API Loader ──────────────────────────────────────────────────────
function loadYouTubeAPI() {
  if (window.YT && window.YT.Player) return Promise.resolve();
  if (window.__ytApiPromise) return window.__ytApiPromise;
  window.__ytApiPromise = new Promise((resolve) => {
    window.onYouTubeIframeAPIReady = resolve;
    const tag = document.createElement("script");
    tag.src = "https://www.youtube.com/iframe_api";
    document.body.appendChild(tag);
  });
  return window.__ytApiPromise;
}

function getYouTubeId(embedUrl) {
  if (!embedUrl) return "";
  const match = embedUrl.match(/embed\/([^?&]+)/);
  return match ? match[1] : "";
}

// ─── Detect video type ────────────────────────────────────────────────────────
function detectVideoType(url) {
  if (!url || url.trim() === "") return "no-video";
  const u = url.toLowerCase();
  if (u.includes("youtube.com") || u.includes("youtu.be")) return "youtube";
  if (
    u.endsWith(".mp4") ||
    u.endsWith(".webm") ||
    u.endsWith(".ogg") ||
    u.includes(".mp4?") ||
    u.includes("gtv-videos-bucket") ||
    u.includes("commondatastorage.googleapis.com") ||
    u.includes("archive.org")
  )
    return "mp4";
  if (u.includes("vimeo.com") || u.includes("dailymotion.com")) return "iframe";
  return "mp4";
}

function buildYouTubeEmbedUrl(raw) {
  try {
    if (raw.includes("watch?v=")) {
      const id = new URLSearchParams(new URL(raw).search).get("v");
      return `https://www.youtube.com/embed/${id}`;
    }
    if (raw.includes("youtu.be/")) {
      const id = raw.split("youtu.be/")[1].split("?")[0];
      return `https://www.youtube.com/embed/${id}`;
    }
    if (raw.includes("embed/")) return raw;
  } catch (e) {}
  return raw;
}

function buildVimeoEmbedUrl(raw) {
  const match = raw.match(/vimeo\.com\/(\d+)/);
  if (match) return `https://player.vimeo.com/video/${match[1]}?autoplay=1`;
  return raw;
}

// ─── Add to Cart helper ──────────────────────────────────────────────────────
// async function addToCartApi(prod_id, onSuccess, onError) {
//   const userId = sessionStorage.getItem("userId");
//   if (!userId) {
//     // alert("Please login first!");
//     sessionStorage.setItem("redirectAfterLogin", window.location.pathname);
//     window.dispatchEvent(new Event("openLoginModal"));

//     return;
//   }
//   try {
//     const res = await axios.post(
//       "https://ecom.cyberathon.com/index.php/Api/insert_cart",
//       { user_id: Number(userId), prod_id: Number(prod_id), qty: 1 }
//     );
//     if (res.data.status === true) onSuccess();
//     else onError(res.data.message || "Failed to add");
//   } catch (e) {
//     console.error(e);
//     onError("Something went wrong");
//   }
// }
async function addToCartApi(prod_id, onSuccess, onError) {
  const userId = sessionStorage.getItem("userId");
  const cartToken = !userId ? getCartToken() : null;

  if (!userId) {
    sessionStorage.setItem("redirectAfterLogin", window.location.pathname);
    window.dispatchEvent(new Event("openLoginModal"));
    return;
  }

  try {
    // pehle check karo item already cart me hai ya nahi
    const listRes = await axios.post(
      "https://ecom.cyberathon.com/index.php/Api/list_cart",
      {
        user_id: userId ? userId : null,
        cart_token: cartToken,
      }
    );

    let cartItem = null;

    if (listRes.data.status) {
      cartItem = listRes.data.cart_items.find(
        (i) => String(i.prod_id) === String(prod_id)
      );
    }

    // agar already hai to success call kar do
    if (cartItem) {
      onSuccess();
      return;
    }

    const res = await axios.post(
      "https://ecom.cyberathon.com/index.php/Api/insert_cart",
      { user_id: Number(userId), prod_id: Number(prod_id), qty: 1 }
    );

    if (res.data.status === true) onSuccess();
    else onError(res.data.message || "Failed to add");
  } catch (e) {
    console.error(e);
    onError("Something went wrong");
  }
}

async function buyNowApi(prod_id, onSuccess, onError) {
  const userId = sessionStorage.getItem("userId");
  const cartToken = !userId ? getCartToken() : null;

  if (!prod_id) {
    onError("This item is not available for purchase yet.");
    return;
  }

  if (!userId) {
    sessionStorage.setItem("redirectAfterLogin", "/Bill");
    window.dispatchEvent(new Event("openLoginModal"));
    return;
  }

  try {
    // cart check
    const listRes = await axios.post(
      "https://ecom.cyberathon.com/index.php/Api/list_cart",
      {
        user_id: userId ? userId : null,
        cart_token: cartToken,
      }
    );

    let cartItem = null;

    if (listRes.data.status) {
      cartItem = listRes.data.cart_items.find(
        (i) => String(i.prod_id) === String(prod_id)
      );
    }

    if (cartItem) {
      await axios.post("https://ecom.cyberathon.com/index.php/Api/update_cart", {
        cart_id: cartItem.cart_id,
        quantity: 1,
        user_id: userId ? userId : null,
        cart_token: cartToken,
      });
    } else {
      await axios.post("https://ecom.cyberathon.com/index.php/Api/insert_cart", {
        user_id: Number(userId),
        prod_id: Number(prod_id),
        qty: 1,
      });
    }

    onSuccess();
  } catch (e) {
    console.error(e);
    onError("Something went wrong");
  }
}

// ─── No-video placeholder ─────────────────────────────────────────────────────
const NoVideoPlaceholder = () => (
  <div className="no-video-placeholder">
    <svg width="38" height="38" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.25)" strokeWidth="1.4">
      <rect x="2" y="2" width="20" height="20" rx="2.5" />
      <path d="M10 8l6 4-6 4V8z" />
      <line x1="2" y1="2" x2="22" y2="22" />
    </svg>
    <span>No Video Available</span>
  </div>
);

// ─── Lock Overlay ─────────────────────────────────────────────────────────────
const LockOverlay = ({ onReplay, prod_id, isAdded, onAddedChange , onBuyNow}) => {
  const [loading, setLoading] = useState(false);
const [buyLoading, setBuyLoading] = useState(false);
  const handleCart = async () => {
    if (isAdded) return;
    setLoading(true);
    await addToCartApi(
      prod_id,
      () => { onAddedChange(true); setLoading(false); },
      (msg) => { alert(msg); setLoading(false); }
    );
  };
const handleBuyNow = async () => {
  if (!prod_id) return;
  setBuyLoading(true);

  await buyNowApi(
    prod_id,
    () => {
      setBuyLoading(false);
      if (onBuyNow) onBuyNow();
    },
    (msg) => {
      alert(msg);
      setBuyLoading(false);
    }
  );
};
  return (
    <div className="lock-overlay">
      <div className="lock-pulse-ring" />
      <div className="lock-icon-wrap">
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="3" y="11" width="18" height="11" rx="2" />
          <path d="M7 11V7a5 5 0 0 1 10 0v4" />
        </svg>
      </div>
      <p className="lock-title">Preview Ended</p>
      <p className="lock-sub">Purchase this course to unlock full access</p>
      {prod_id && (
        <button
          className={`btn-lock-cart${isAdded ? " added" : ""}`}
          onClick={handleCart}
          disabled={loading || isAdded}
        >
          {loading ? (
            <span className="cs-spinner" />
          ) : isAdded ? (
            <><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="20 6 9 17 4 12" /></svg>Added to Cart</>
          ) : (
            <><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="9" cy="21" r="1" /><circle cx="20" cy="21" r="1" /><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" /></svg>Add to Cart</>
          )}
        </button>
      )}
      
      <button className="btn-replay" onClick={onReplay}>
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2"><polyline points="1 4 1 10 7 10" /><path d="M3.51 15a9 9 0 1 0 .49-6" /></svg>
        Watch Preview Again
      </button>
    </div>
  );
};

// ─── Video Error Fallback ─────────────────────────────────────────────────────
const VideoErrorFallback = ({ onRetry }) => (
  <div className="video-error-fallback">
    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.3)" strokeWidth="1.5">
      <circle cx="12" cy="12" r="10" />
      <line x1="12" y1="8" x2="12" y2="12" />
      <line x1="12" y1="16" x2="12.01" y2="16" />
    </svg>
    <span>Video could not be loaded</span>
    {onRetry && <button className="btn-retry" onClick={onRetry}>Try Again</button>}
  </div>
);

// ─── MP4 Card ─────────────────────────────────────────────────────────────────
const Mp4VideoCard = ({ video, isPurchased, isAdded: initAdded, onCartChange, onNavigate }) => {
  const [phase, setPhase] = useState("idle");
  const [isAdded, setIsAdded] = useState(initAdded);
  const [cartLoading, setCartLoading] = useState(false);
  const videoRef = useRef(null);
  const timerRef = useRef(null);

  useEffect(() => { setIsAdded(initAdded); }, [initAdded]);
  const handlePlay = () => setPhase("playing");

  useEffect(() => {
    if (phase !== "playing") return;
    const vid = videoRef.current;
    if (!vid || isPurchased) return;
    const onPlay = () => {
      timerRef.current = setTimeout(() => { vid.pause(); setPhase("locked"); }, FREE_SECONDS * 1000);
    };
    vid.addEventListener("play", onPlay);
    return () => { vid.removeEventListener("play", onPlay); clearTimeout(timerRef.current); };
  }, [phase, isPurchased]);

  const handleReplay = () => { clearTimeout(timerRef.current); setPhase("idle"); };
  const handleAddedChange = (val) => { setIsAdded(val); if (onCartChange) onCartChange(video.prod_id, val); };
  const handleCartClick = async () => {
    if (isAdded) return;
    setCartLoading(true);
    await addToCartApi(video.prod_id,
      () => { setIsAdded(true); if (onCartChange) onCartChange(video.prod_id, true); setCartLoading(false); },
      (msg) => { alert(msg); setCartLoading(false); }
    );
  };

  return (
    <div className="course-card">
      <div className="video-area">
        {isPurchased
          ? <span className="badge badge-purchased"><svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3"><polyline points="20 6 9 17 4 12" /></svg>Purchased</span>
          : <span className="badge badge-preview"><svg width="10" height="10" viewBox="0 0 24 24" fill="currentColor"><polygon points="5,3 19,12 5,21" /></svg>{FREE_SECONDS}s Free Preview</span>
        }
        {phase === "idle" && (
          <>
            <video src={`${video.embedUrl}#t=0.5`} style={{ width: "100%", height: "100%", objectFit: "cover" }} preload="metadata" muted playsInline />
            <div className="play-overlay">
              <button className="play-btn" onClick={handlePlay}>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="white"><polygon points="5,3 19,12 5,21" /></svg>
              </button>
            </div>
          </>
        )}
        {(phase === "playing" || phase === "locked") && (
          <>
            <video ref={videoRef} src={video.embedUrl} controls={isPurchased} autoPlay playsInline onError={() => setPhase("error")} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
            {phase === "locked" && <LockOverlay onReplay={handleReplay} prod_id={video.prod_id} isAdded={isAdded} onAddedChange={handleAddedChange} />}
          </>
        )}
        {phase === "error" && <VideoErrorFallback onRetry={() => setPhase("idle")} />}
      </div>
      <CardBody video={video} isPurchased={isPurchased} isAdded={isAdded} cartLoading={cartLoading} onWatch={handlePlay} onCart={handleCartClick} onNavigate={onNavigate} />
    </div>
  );
};

// ─── YouTube Card ─────────────────────────────────────────────────────────────
const YoutubeVideoCard = ({ video, isPurchased, isAdded: initAdded, onCartChange, onNavigate }) => {
  const [phase, setPhase] = useState("thumbnail");
  const [isAdded, setIsAdded] = useState(initAdded);
  const [cartLoading, setCartLoading] = useState(false);
  const timerRef = useRef(null);
  const playerRef = useRef(null);
  const divId = `yt-player-${video.prod_id}`;
  const videoId = getYouTubeId(video.embedUrl);
  const thumbUrl = videoId ? `https://img.youtube.com/vi/${videoId}/hqdefault.jpg` : null;

  useEffect(() => { setIsAdded(initAdded); }, [initAdded]);

  const handlePlay = async () => {
    setPhase("playing");
    await loadYouTubeAPI();
    setTimeout(() => {
      playerRef.current = new window.YT.Player(divId, {
        events: {
          onReady: (e) => {
            e.target.playVideo();
            if (!isPurchased) {
              timerRef.current = setTimeout(() => { e.target.pauseVideo(); setPhase("locked"); }, FREE_SECONDS * 1000);
            }
          },
        },
      });
    }, 300);
  };

  const handleReplay = () => {
    clearTimeout(timerRef.current);
    if (playerRef.current) { try { playerRef.current.destroy(); } catch (e) {} playerRef.current = null; }
    setPhase("thumbnail");
  };

  useEffect(() => () => {
    clearTimeout(timerRef.current);
    if (playerRef.current) { try { playerRef.current.destroy(); } catch (e) {} }
  }, []);

  const handleAddedChange = (val) => { setIsAdded(val); if (onCartChange) onCartChange(video.prod_id, val); };
  const handleCartClick = async () => {
    if (isAdded) return;
    setCartLoading(true);
    await addToCartApi(video.prod_id,
      () => { setIsAdded(true); if (onCartChange) onCartChange(video.prod_id, true); setCartLoading(false); },
      (msg) => { alert(msg); setCartLoading(false); }
    );
  };

  return (
    <div className="course-card">
      <div className="video-area">
        {isPurchased
          ? <span className="badge badge-purchased"><svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3"><polyline points="20 6 9 17 4 12" /></svg>Purchased</span>
          : <span className="badge badge-preview"><svg width="10" height="10" viewBox="0 0 24 24" fill="currentColor"><polygon points="5,3 19,12 5,21" /></svg>{FREE_SECONDS}s Free Preview</span>
        }
        {phase === "thumbnail" && (
          <>
            {thumbUrl
              ? <img src={thumbUrl} alt={video.heading} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
              : <div style={{ width: "100%", height: "100%", background: "#0d1117" }} />
            }
            <div className="play-overlay">
              <button className="play-btn" onClick={handlePlay}>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="white"><polygon points="5,3 19,12 5,21" /></svg>
              </button>
            </div>
          </>
        )}
        {(phase === "playing" || phase === "locked") && (
          <>
            <iframe id={divId} src={`https://www.youtube.com/embed/${videoId}?enablejsapi=1`} title={video.heading} allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen style={{ width: "100%", height: "100%", border: "none" }} />
            {phase === "locked" && <LockOverlay onReplay={handleReplay} prod_id={video.prod_id} isAdded={isAdded} onAddedChange={handleAddedChange} />}
          </>
        )}
      </div>
      <CardBody video={video} isPurchased={isPurchased} isAdded={isAdded} cartLoading={cartLoading} onWatch={handlePlay} onCart={handleCartClick} onNavigate={onNavigate} />
    </div>
  );
};

// ─── IFrame Card ──────────────────────────────────────────────────────────────
const IframeVideoCard = ({ video, isPurchased, isAdded: initAdded, onCartChange, onNavigate }) => {
  const [phase, setPhase] = useState("thumbnail");
  const [isAdded, setIsAdded] = useState(initAdded);
  const [cartLoading, setCartLoading] = useState(false);
  const timerRef = useRef(null);

  useEffect(() => { setIsAdded(initAdded); }, [initAdded]);
  const handlePlay = () => {
    setPhase("playing");
    if (!isPurchased) timerRef.current = setTimeout(() => setPhase("locked"), FREE_SECONDS * 1000);
  };
  const handleReplay = () => { clearTimeout(timerRef.current); setPhase("thumbnail"); };
  useEffect(() => () => clearTimeout(timerRef.current), []);

  const handleAddedChange = (val) => { setIsAdded(val); if (onCartChange) onCartChange(video.prod_id, val); };
  const handleCartClick = async () => {
    if (isAdded) return;
    setCartLoading(true);
    await addToCartApi(video.prod_id,
      () => { setIsAdded(true); if (onCartChange) onCartChange(video.prod_id, true); setCartLoading(false); },
      (msg) => { alert(msg); setCartLoading(false); }
    );
  };

  const iframeSrc = video.embedUrl.includes("vimeo") ? buildVimeoEmbedUrl(video.embedUrl) : video.embedUrl;

  return (
    <div className="course-card">
      <div className="video-area">
        {isPurchased
          ? <span className="badge badge-purchased"><svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3"><polyline points="20 6 9 17 4 12" /></svg>Purchased</span>
          : <span className="badge badge-preview"><svg width="10" height="10" viewBox="0 0 24 24" fill="currentColor"><polygon points="5,3 19,12 5,21" /></svg>{FREE_SECONDS}s Free Preview</span>
        }
        {phase === "thumbnail" && (
          <div className="play-overlay" style={{ background: "rgba(0,0,0,0.55)" }}>
            <button className="play-btn" onClick={handlePlay}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="white"><polygon points="5,3 19,12 5,21" /></svg>
            </button>
          </div>
        )}
        {(phase === "playing" || phase === "locked") && (
          <>
            <iframe src={iframeSrc} title={video.heading} allow="autoplay; fullscreen" allowFullScreen style={{ width: "100%", height: "100%", border: "none" }} />
            {phase === "locked" && <LockOverlay onReplay={handleReplay} prod_id={video.prod_id} isAdded={isAdded} onAddedChange={handleAddedChange} />}
          </>
        )}
      </div>
      <CardBody video={video} isPurchased={isPurchased} isAdded={isAdded} cartLoading={cartLoading} onWatch={handlePlay} onCart={handleCartClick} onNavigate={onNavigate} />
    </div>
  );
};

// ─── No Video Card ────────────────────────────────────────────────────────────
const NoVideoCard = ({ video, isPurchased, isAdded: initAdded, onCartChange, onNavigate }) => {
  const [isAdded, setIsAdded] = useState(initAdded);
  const [cartLoading, setCartLoading] = useState(false);

  useEffect(() => { setIsAdded(initAdded); }, [initAdded]);
  const handleCartClick = async () => {
    if (isAdded) return;
    setCartLoading(true);
    await addToCartApi(video.prod_id,
      () => { setIsAdded(true); if (onCartChange) onCartChange(video.prod_id, true); setCartLoading(false); },
      (msg) => { alert(msg); setCartLoading(false); }
    );
  };

  return (
    <div className="course-card">
      <div className="video-area">
        {isPurchased && <span className="badge badge-purchased"><svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3"><polyline points="20 6 9 17 4 12" /></svg>Purchased</span>}
        <NoVideoPlaceholder />
      </div>
      <CardBody video={video} isPurchased={isPurchased} isAdded={isAdded} cartLoading={cartLoading} onWatch={null} onCart={handleCartClick} onNavigate={onNavigate} />
    </div>
  );
};

// ─── Shared Card Body ─────────────────────────────────────────────────────────
// const CardBody = ({ video, isPurchased, isAdded, cartLoading, onWatch, onCart, onNavigate }) => (
  const CardBody = ({ video, isPurchased, isAdded, cartLoading, buyLoading, onWatch, onCart, onBuyNow, onNavigate }) => (
  <div className="card-body-inner">
    <h3
      className="card-title"
      style={{ cursor: onNavigate ? "pointer" : "default" }}
      onClick={onNavigate}
    >
      {video.heading}
    </h3>

    {video.description && (
      <div className="card-desc html-content">
        <HtmlContent html={video.description} maxLines={3} />
      </div>
    )}

    <div className="price-row">
      {video.current_price && Number(video.current_price) > 0 ? (
        <>
          <span className="price-current">₹{Number(video.current_price).toLocaleString("en-IN")}</span>
          {video.old_price && Number(video.old_price) > 0 && (
            <span className="price-old">₹{Number(video.old_price).toLocaleString("en-IN")}</span>
          )}
        </>
      ) : (
        <span className="price-free">Free</span>
      )}
    </div>

    {!video.prod_id ? (
      <div className="no-prod-tag">
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" /></svg>
        Not available for purchase
      </div>
    ) : isPurchased ? (
      <div style={{ display: "flex", flexDirection: "column", gap: 8, marginTop: "auto" }}>
        {onWatch && (
          <button className="btn-watch" onClick={onWatch}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="white"><polygon points="5,3 19,12 5,21" /></svg>
            Watch Full Course
          </button>
        )}
        {onNavigate && (
          <button className="btn-view-details" onClick={onNavigate}>
            View Course Details
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2"><polyline points="9 18 15 12 9 6" /></svg>
          </button>
        )}
      </div>
    ) : (
      // <div style={{ display: "flex", flexDirection: "column", gap: 8, marginTop: "auto" }}>
      //   <button
      //     className={`btn-cart${isAdded ? " added" : ""}`}
      //     onClick={onCart}
      //     disabled={cartLoading || isAdded}
      //   >
      //     {cartLoading ? (
      //       <span className="cs-spinner" />
      //     ) : isAdded ? (
      //       <><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="20 6 9 17 4 12" /></svg>Added to Cart</>
      //     ) : (
      //       <><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="9" cy="21" r="1" /><circle cx="20" cy="21" r="1" /><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" /></svg>Add to Cart</>
      //     )}
      //   </button>
      //   {onNavigate && (
      //     <button className="btn-view-details" onClick={onNavigate}>
      //       View Course Details
      //       <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2"><polyline points="9 18 15 12 9 6" /></svg>
      //     </button>
      //   )}
      // </div>
      <div style={{ display: "flex", flexDirection: "column", gap: 8, marginTop: "auto" }}>
  <div className="course-action-row">
    <button
      className={`btn-cart${isAdded ? " added" : ""}`}
      onClick={onCart}
      disabled={cartLoading || isAdded}
    >
      {cartLoading ? (
        <span className="cs-spinner" />
      ) : isAdded ? (
        <><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="20 6 9 17 4 12" /></svg>Added to Cart</>
      ) : (
        <><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="9" cy="21" r="1" /><circle cx="20" cy="21" r="1" /><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" /></svg>Add to Cart</>
      )}
    </button>

    <button
      className="btn-buy-now"
      onClick={onBuyNow}
      disabled={buyLoading}
    >
      {buyLoading ? <span className="cs-spinner" /> : "Buy Now"}
    </button>
  </div>

  {onNavigate && (
    <button className="btn-view-details" onClick={onNavigate}>
      View Course Details
      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2"><polyline points="9 18 15 12 9 6" /></svg>
    </button>
  )}
</div>
// LAST code 19march
    )}
  </div>
);

// ─── MAIN COMPONENT ───────────────────────────────────────────────────────────
const CourseSection2 = () => {
  const navigate = useNavigate();

  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [purchasedProdIds, setPurchasedProdIds] = useState(new Set());
  const [cartProdIds, setCartProdIds] = useState(new Set());

  useEffect(() => {
    const load = async () => {
      try {
        const res = await axios.get(API_URL);

        if (!res.data?.status) {
          setError("No products found");
          return;
        }

        const products = Array.isArray(res.data.products) ? res.data.products : [];

        const list = products
          // ✅ Only coursesection type
          .filter((p) => p.product_type && p.product_type.toLowerCase() === "coursesection")
          .map((p) => {
            // ✅ video field holds the raw URL for coursesection products
            let rawUrl = p.video || p.video_url || p.product_video || "";

            // ✅ Fix relative URLs
            if (rawUrl && !rawUrl.startsWith("http")) {
              rawUrl = BASE_URL + rawUrl;
            }

            const type = detectVideoType(rawUrl);

            let embedUrl = rawUrl;
            if (type === "youtube") {
              embedUrl = buildYouTubeEmbedUrl(rawUrl);
            }

            return {
              // ✅ Keep both id (ref_id) and prod_id — prod_id is used everywhere
              id: p.id || p.ref_id,
              prod_id: p.prod_id,

              heading: p.heading || p.product_name || p.title || "Untitled Course",
              description: p.description || "",
              details: p.details || "",

              current_price: p.current_price || 0,
              old_price: p.old_price || 0,

              embedUrl,
              type,
            };
          });

        setVideos(list);
      } catch (e) {
        console.error("API Error:", e);
        setError("Failed to fetch products");
      } finally {
        setLoading(false);
      }
    };

    load();
  }, []);

  useEffect(() => {
    const init = async () => {
      const userId = sessionStorage.getItem("userId");
      const cartToken = localStorage.getItem("cart_token");

      if (userId || cartToken) {
        try {
          const res = await axios.post("https://ecom.cyberathon.com/index.php/Api/list_cart", {
            user_id: userId || null,
            cart_token: userId ? null : cartToken,
          });
          if (res.data.status) {
            setCartProdIds(new Set(res.data.cart_items.map((i) => String(i.prod_id))));
          }
        } catch (e) { console.error(e); }
      }

      if (userId) {
        try {
          const res = await axios.post("https://ecom.cyberathon.com/index.php/Api/list_new_order", {
            user_id: parseInt(userId),
          });
          if (res.data.status && Array.isArray(res.data.orders)) {
            const ids = new Set();
            res.data.orders.forEach((order) => {
              if (!Array.isArray(order.items)) return;
              order.items.forEach((item) => {
                if (!item.prod_id) return;
                if (
                  item.access === "unlocked" ||
                  order.purchase_status === "yes" ||
                  order.payment_status === "Paid" ||
                  order.payment_status === "paid" ||
                  order.order_status === "Delivered" ||
                  order.order_status === "Completed"
                ) {
                  ids.add(String(item.prod_id));
                }
              });
            });
            setPurchasedProdIds(ids);
          }
        } catch (e) { console.error(e); }
      }
    };
    init();
  }, []);

  const handleCartChange = (prod_id, added) => {
    setCartProdIds((prev) => {
      const next = new Set(prev);
      if (added) next.add(String(prod_id));
      else next.delete(String(prod_id));
      return next;
    });
  };

  const renderCard = (v) => {
    const strId = String(v.prod_id);
    const isPurchased = purchasedProdIds.has(strId);
    const isAdded = cartProdIds.has(strId);
    const props = {
      key: v.prod_id,
      video: v,
      isPurchased,
      isAdded,
      onCartChange: handleCartChange,
      // ✅ Navigate using prod_id — matches the route /coursesectiondetail/:id
      onNavigate: () => navigate(`/coursesectiondetail/${v.prod_id}`),
    };

    switch (v.type) {
      case "youtube":  return <YoutubeVideoCard {...props} />;
      case "mp4":      return <Mp4VideoCard {...props} />;
      case "iframe":   return <IframeVideoCard {...props} />;
      case "no-video": return <NoVideoCard {...props} />;
      default:         return <Mp4VideoCard {...props} />;
    }
  };

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&family=DM+Sans:wght@400;500;600&display=swap');

        :root {
          --teal: #0ecfce;
          --teal-dark: #0ab5b4;
          --green: #22c55e;
          --green-dark: #16a34a;
          --card-bg: #ffffff;
          --card-border: #e5f0f0;
          --card-hover-border: #0ecfce;
          --text-primary: #0f172a;
          --text-secondary: #475569;
          --text-muted: #94a3b8;
          --surface: #f7fffe;
        }

        .cs-root {
          background: var(--surface);
          min-height: 60vh;
          padding: 64px 0 80px;
          font-family: 'DM Sans', sans-serif;
        }

        .cs-header { text-align: center; margin-bottom: 52px; padding: 0 16px; }
        .cs-eyebrow {
          display: inline-flex; align-items: center; gap: 6px;
          background: rgba(14,207,206,0.1); color: #0891b2;
          font-size: 11.5px; font-weight: 700; letter-spacing: 1px;
          text-transform: uppercase; padding: 5px 14px;
          border-radius: 100px; margin-bottom: 16px;
          font-family: 'Plus Jakarta Sans', sans-serif;
        }
        .cs-heading {
          font-family: 'Plus Jakarta Sans', sans-serif;
          font-size: clamp(1.9rem, 3.5vw, 2.8rem); font-weight: 800;
          color: var(--text-primary); margin: 0 0 10px;
          letter-spacing: -0.8px; line-height: 1.15;
        }
        .cs-sub { color: var(--text-muted); font-size: 15px; margin: 0; }

        .cs-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(310px, 1fr));
          gap: 24px; padding: 0 24px;
          max-width: 1240px; margin: 0 auto;
        }

        .course-card {
          background: var(--card-bg);
          border: 1.5px solid var(--card-border);
          border-radius: 20px; overflow: hidden;
          display: flex; flex-direction: column;
          transition: transform 0.28s cubic-bezier(.22,.68,0,1.2), box-shadow 0.28s ease, border-color 0.2s ease;
          animation: csCardIn 0.45s ease both;
          position: relative;
        }
        .course-card:hover {
          transform: translateY(-7px);
          box-shadow: 0 20px 52px rgba(14,207,206,0.12), 0 4px 16px rgba(0,0,0,0.05);
          border-color: var(--card-hover-border);
        }
        @keyframes csCardIn {
          from { opacity: 0; transform: translateY(22px); }
          to   { opacity: 1; transform: translateY(0); }
        }

        .video-area {
          position: relative; width: 100%; height: 205px;
          background: #0d1117; overflow: hidden; flex-shrink: 0;
        }
        .video-area img, .video-area video, .video-area iframe {
          width: 100%; height: 100%; object-fit: cover; display: block;
        }

        .no-video-placeholder {
          width: 100%; height: 100%;
          display: flex; flex-direction: column;
          align-items: center; justify-content: center;
          gap: 10px; background: #0d1117;
        }
        .no-video-placeholder span {
          font-size: 12px; color: rgba(255,255,255,0.2);
          font-family: 'DM Sans', sans-serif;
        }

        .video-error-fallback {
          width: 100%; height: 100%;
          display: flex; flex-direction: column;
          align-items: center; justify-content: center;
          gap: 10px; background: #0d1117; padding: 20px; text-align: center;
        }
        .video-error-fallback span { font-size: 12px; color: rgba(255,255,255,0.25); font-family: 'DM Sans', sans-serif; }
        .btn-retry {
          background: rgba(14,207,206,0.12); color: var(--teal);
          border: 1px solid rgba(14,207,206,0.3); border-radius: 8px;
          padding: 5px 14px; font-size: 11.5px; font-weight: 600;
          cursor: pointer; font-family: 'DM Sans', sans-serif; transition: background 0.2s;
        }
        .btn-retry:hover { background: rgba(14,207,206,0.2); }

        .play-overlay {
          position: absolute; inset: 0;
          background: rgba(0,0,0,0.28);
          display: flex; align-items: center; justify-content: center;
          z-index: 4; transition: background 0.2s; cursor: pointer;
        }
        .play-overlay:hover { background: rgba(0,0,0,0.4); }

        .play-btn {
          width: 56px; height: 56px; border-radius: 50%;
          background: var(--teal); border: 3px solid rgba(255,255,255,0.25);
          display: flex; align-items: center; justify-content: center;
          cursor: pointer;
          transition: transform 0.2s cubic-bezier(.22,.68,0,1.4), background 0.2s;
          box-shadow: 0 4px 24px rgba(14,207,206,0.4);
        }
        .play-btn:hover { transform: scale(1.12); background: var(--teal-dark); }
        .play-btn svg { margin-left: 3px; }

        .badge {
          position: absolute; top: 12px; left: 12px;
          display: inline-flex; align-items: center; gap: 5px;
          font-size: 11px; font-weight: 700; padding: 4px 10px;
          border-radius: 100px; z-index: 5; letter-spacing: 0.2px;
          font-family: 'Plus Jakarta Sans', sans-serif; backdrop-filter: blur(8px);
        }
        .badge-preview { background: rgba(14,207,206,0.18); color: #fff; border: 1px solid rgba(14,207,206,0.4); }
        .badge-purchased { background: rgba(34,197,94,0.18); color: #fff; border: 1px solid rgba(34,197,94,0.4); }

        .lock-overlay {
          position: absolute; inset: 0;
          background: rgba(8,12,20,0.93); backdrop-filter: blur(6px);
          display: flex; flex-direction: column;
          align-items: center; justify-content: center;
          z-index: 10; padding: 24px 20px; text-align: center; gap: 9px;
          animation: csLockIn 0.22s ease;
        }
        @keyframes csLockIn { from { opacity: 0; transform: scale(0.97); } to { opacity: 1; transform: scale(1); } }
        .lock-pulse-ring {
          position: absolute; width: 90px; height: 90px; border-radius: 50%;
          border: 1.5px solid rgba(14,207,206,0.22);
          animation: lockPulse 2s ease-in-out infinite; pointer-events: none;
        }
        @keyframes lockPulse { 0%, 100% { transform: scale(1); opacity: 0.5; } 50% { transform: scale(1.35); opacity: 0; } }
        .lock-icon-wrap {
          width: 58px; height: 58px; border-radius: 50%;
          background: rgba(14,207,206,0.1); border: 1.5px solid rgba(14,207,206,0.3);
          display: flex; align-items: center; justify-content: center;
          position: relative; z-index: 1;
        }
        .lock-title { font-family: 'Plus Jakarta Sans', sans-serif; font-size: 15px; font-weight: 800; color: #f1f5f9; margin: 2px 0 0; }
        .lock-sub { font-size: 12px; color: #64748b; margin: 0; line-height: 1.55; max-width: 200px; }
        .btn-lock-cart {
          background: var(--teal); color: #fff; border: none; border-radius: 10px;
          padding: 9px 22px; font-size: 13px; font-weight: 700; cursor: pointer;
          display: flex; align-items: center; gap: 7px;
          transition: opacity 0.2s, transform 0.15s;
          font-family: 'Plus Jakarta Sans', sans-serif; margin-top: 2px;
        }
        .btn-lock-cart:hover:not(:disabled) { opacity: 0.88; transform: translateY(-1px); }
        .btn-lock-cart.added { background: #16a34a; cursor: default; }
        .btn-lock-cart:disabled { opacity: 0.7; }
        .btn-replay {
          background: transparent; color: #475569; border: 1px solid #2d3748;
          border-radius: 8px; padding: 6px 14px; font-size: 11.5px; font-weight: 600;
          cursor: pointer; display: flex; align-items: center; gap: 5px;
          transition: color 0.2s, border-color 0.2s; font-family: 'DM Sans', sans-serif;
        }
        .btn-replay:hover { color: #94a3b8; border-color: #475569; }

        .card-body-inner { padding: 18px 20px 20px; display: flex; flex-direction: column; flex: 1; gap: 10px; }
        .card-title {
          font-family: 'Plus Jakarta Sans', sans-serif;
          font-size: 15.5px; font-weight: 700; color: var(--text-primary);
          margin: 0; line-height: 1.4; letter-spacing: -0.2px; transition: color 0.15s;
        }
        .card-title:hover { color: var(--teal); }

        .html-content ul, .html-content ol { padding-left: 20px; margin: 4px 0; }
        .html-content ul li, .html-content ol li { color: var(--text-secondary); font-size: 13px; margin-bottom: 3px; line-height: 1.6; list-style-type: disc; }
        .html-content ol li { list-style-type: decimal; }
        .html-content p { margin: 0 0 4px; color: var(--text-secondary); font-size: 13px; line-height: 1.65; }
        .html-content strong { color: var(--text-primary); }
        .html-content a { color: var(--teal); text-decoration: none; }

        .card-desc { font-size: 13px; color: var(--text-secondary); line-height: 1.65; }

        .price-row { display: flex; align-items: baseline; gap: 10px; margin-top: 2px; }
        .price-current { font-family: 'Plus Jakarta Sans', sans-serif; font-size: 21px; font-weight: 800; color: var(--green); letter-spacing: -0.5px; }
        .price-old { font-size: 13.5px; color: var(--text-muted); text-decoration: line-through; font-weight: 500; }
        .price-free { font-family: 'Plus Jakarta Sans', sans-serif; font-size: 16px; font-weight: 700; color: var(--teal); }

        .no-prod-tag {
          display: inline-flex; align-items: center; gap: 5px;
          color: var(--text-muted); font-size: 12px; font-weight: 500;
          padding: 8px 12px; border-radius: 8px;
          background: #f8fafc; border: 1px dashed #e2e8f0;
          font-family: 'DM Sans', sans-serif; margin-top: auto;
        }

        .btn-cart {
          padding: 12px 0; border-radius: 12px;
          border: 1.5px solid var(--teal); font-size: 13.5px; font-weight: 700;
          cursor: pointer; background: transparent; color: var(--teal);
          width: 100%; display: flex; align-items: center; justify-content: center;
          gap: 7px; letter-spacing: 0.1px;
          transition: background 0.2s, color 0.2s, transform 0.15s;
          font-family: 'Plus Jakarta Sans', sans-serif;
        }
        .btn-cart:hover:not(:disabled):not(.added) { background: var(--teal); color: #fff; transform: translateY(-1px); }
        .btn-cart.added { background: #f0fdf4; border-color: var(--green); color: var(--green-dark); cursor: default; }
        .btn-cart:disabled:not(.added) { opacity: 0.65; cursor: not-allowed; }

        .btn-watch {
          padding: 12px 0; border-radius: 12px; border: none;
          font-size: 13.5px; font-weight: 700; cursor: pointer;
          background: linear-gradient(135deg, #22c55e, #16a34a); color: #fff;
          width: 100%; display: flex; align-items: center; justify-content: center;
          gap: 7px; transition: opacity 0.2s, transform 0.15s;
          font-family: 'Plus Jakarta Sans', sans-serif;
        }
        .btn-watch:hover { opacity: 0.9; transform: translateY(-1px); }

        .btn-view-details {
          padding: 9px 0; border-radius: 10px;
          border: 1px solid var(--card-border);
          font-size: 13px; font-weight: 600;
          cursor: pointer; background: #f8fffe; color: var(--teal);
          width: 100%; display: flex; align-items: center; justify-content: center;
          gap: 5px; transition: background 0.2s, border-color 0.2s;
          font-family: 'Plus Jakarta Sans', sans-serif;
        }
        .btn-view-details:hover { background: rgba(14,207,206,0.06); border-color: var(--teal); }

        .cs-spinner {
          display: inline-block; width: 15px; height: 15px;
          border: 2px solid rgba(255,255,255,0.3); border-top-color: #fff;
          border-radius: 50%; animation: csSpin 0.7s linear infinite;
        }
        @keyframes csSpin { to { transform: rotate(360deg); } }

        .cs-skeleton-card { background: white; border-radius: 20px; overflow: hidden; border: 1.5px solid #f1f5f9; }
        .cs-skeleton {
          background: linear-gradient(90deg, #f8fafc 25%, #f1f5f9 50%, #f8fafc 75%);
          background-size: 200% 100%; animation: csSkeleton 1.5s ease-in-out infinite; border-radius: 6px;
        }
        @keyframes csSkeleton { 0% { background-position: -200% 0; } 100% { background-position: 200% 0; } }

        @media (max-width: 600px) {
          .cs-grid { padding: 0 12px; gap: 16px; }
          .cs-heading { font-size: 1.7rem; }
        }
      `}</style>

      <div className="cs-root">
        <div className="container-fluid px-0">
          <h1 className="text-center fw-bold text-bold pb-5">Our Courses</h1>

          {loading && (
            <div className="cs-grid">
              {[1, 2, 3].map((n) => (
                <div key={n} className="cs-skeleton-card">
                  <div className="cs-skeleton" style={{ height: 205, borderRadius: 0 }} />
                  <div style={{ padding: "18px 20px 20px", display: "flex", flexDirection: "column", gap: 10 }}>
                    <div className="cs-skeleton" style={{ height: 18, width: "85%" }} />
                    <div className="cs-skeleton" style={{ height: 13, width: "70%" }} />
                    <div className="cs-skeleton" style={{ height: 13, width: "55%" }} />
                    <div className="cs-skeleton" style={{ height: 28, width: "40%", marginTop: 4 }} />
                    <div className="cs-skeleton" style={{ height: 46, borderRadius: 12, marginTop: 8 }} />
                  </div>
                </div>
              ))}
            </div>
          )}

          {error && (
            <p style={{ textAlign: "center", color: "#ef4444", padding: 40 }}>{error}</p>
          )}

          {!loading && !error && videos.length === 0 && (
            <p style={{ textAlign: "center", color: "#94a3b8", padding: 40 }}>No courses found.</p>
          )}

          {!loading && !error && (
            <div className="cs-grid">
              {videos.map((v) => renderCard(v))}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default CourseSection2;